import React from 'react';
import axios from 'axios';
import { cleanTermForURL } from '../../../../../util/cleanTermForURL';
import { updatePersonalizationStorage, getFavoritedBrandsByCategoryid } from '../../../../../util/personalization.js';
import { shouldShowImboxModal } from '../../../Shared/Content/Imbox/imboxUtils.js';

var supersToDoSizeTracking = ['410', '430', '425', '480', '445'];

let prevItem = '';
let prevItem2 = '';
let prevItem3 = '';

// NOT THESE: [420,435,450,440,470]
export class SharedProductDetail extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      allImages: [],
      imageClickedOn: false,
      addToBagClicked: false,
      showReviews: false,
      checkForErrors: false,
      subscriptionFrequency: '',
      isSyndigoLoaded: false,
      videoChatAvailable: false,
      productId: '',
      correctPassedAttributes: '',
      correctContentData: '',
      possibleIncorrectProductId: false,
      productImagesArray: JSON.parse(JSON.stringify(this.props.contentData.altImages || [])),
      isAddToBrandFavs: false,
    };

    this.setDefaultImageByURLParam(
      this.props.passedAppFunctions.getURLParamValue('df'),
      this.props.passedAppFunctions.getURLParamValue('di'),
      this.props
    );
    if (props.contentData.productId) this.initializeStateObjects(this.props.contentData, true);
    this.updateQuantity = this.updateQuantity.bind(this);
    this.forceQuantity = this.forceQuantity.bind(this);
    this.updateAttribute = this.updateAttribute.bind(this);
    this.ajaxAddToBag = this.ajaxAddToBag.bind(this);
    this.ajaxAddToWishlist = this.ajaxAddToWishlist.bind(this);
    this.ajaxAddToBrandFavorites = this.ajaxAddToBrandFavorites.bind(this);
    this.validateForm = this.validateForm.bind(this);
    this.updateSwatchGroups = this.updateSwatchGroups.bind(this);
    this.changeAttributeState = this.changeAttributeState.bind(this);
    this.updateAttributeFromAltClick = this.updateAttributeFromAltClick.bind(this);
    this.updateAttributeFromAltSwipe = this.updateAttributeFromAltSwipe.bind(this);
    this.flatSizesPriceObject = this.flatSizesPriceObject.bind(this);
    this.closeWishListMessage = this.closeWishListMessage.bind(this);
    this.mainImageClicked = this.mainImageClicked.bind(this);
    this.zoomedImageClose = this.zoomedImageClose.bind(this);
    this.ajaxShareProductModal = this.ajaxShareProductModal.bind(this);
    this.ajaxAddToRegistry = this.ajaxAddToRegistry.bind(this);
    this.willHaveFlatAttribute = this.willHaveFlatAttribute.bind(this);
    this.shouldShowFreeShipping = this.shouldShowFreeShipping.bind(this);
    this.updateAttributeState2 = this.updateAttributeState2.bind(this);
    this.thisBrandInMyFavorites = this.thisBrandInMyFavorites.bind(this);
    this.getPersonalizationCategoryId = this.getPersonalizationCategoryId.bind(this);
    this.forceBundleRender = this.forceBundleRender.bind(this);
    this.addToBagClicked = this.addToBagClicked.bind(this);
    this.formNotValid = this.formNotValid.bind(this);
    this.checkForErrorsRegistry = this.checkForErrorsRegistry.bind(this);
    this.checkForErrors = this.checkForErrors.bind(this);
    this.checkForErrorsWishlist = this.checkForErrorsWishlist.bind(this);
    this.hideCheckForErrors = this.hideCheckForErrors.bind(this);
    this.checkForErrorsItemAttr = this.checkForErrorsItemAttr.bind(this);
    this.checkForErrorsQV = this.checkForErrorsQV.bind(this);
    this.returnItemColorOrTrueIfMonogramEligible = this.returnItemColorOrTrueIfMonogramEligible.bind(this);
    this.ajaxMonogramPersonalization = this.ajaxMonogramPersonalization.bind(this);
    this.thisItemMonogramEligible = this.thisItemMonogramEligible.bind(this);
    this.ajaxMonogramPersonalization = this.ajaxMonogramPersonalization.bind(this);
    this.checkForErrorsMonogram = this.checkForErrorsMonogram.bind(this);
    this.searchABTracking = this.searchABTracking.bind(this);
    this.updateLiveReviewCounts = this.updateLiveReviewCounts.bind(this);
    this.focusFirstAttrError = this.focusFirstAttrError.bind(this);
    this.updateSubscriptionFrequency = this.updateSubscriptionFrequency.bind(this);
    this.checkVideoChat = this.checkVideoChat.bind(this);
    this.updateLiveQuestionAnswersCount = this.updateLiveQuestionAnswersCount.bind(this);
    this.mainImageLoaded = this.mainImageLoaded.bind(this);
    this.changeMainImage = this.changeMainImage.bind(this);
    this.checkMainImageLoad = this.checkMainImageLoad.bind(this);
    this.altImageClicked = this.altImageClicked.bind(this);
    this.updateDataLayer(this.props);
    this.getPageType = this.getPageType.bind(this);
    this.updateAttributeState = this.updateAttributeState.bind(this);
    this.buildSwatchGroupsFromSkus = this.buildSwatchGroupsFromSkus.bind(this);
    this.getProductImagesArray = this.getProductImagesArray.bind(this);
    this.getAttrName = this.getAttrName.bind(this);
    this.getAttrId = this.getAttrId.bind(this);
    this.getAttrType = this.getAttrType.bind(this);
  }

  getPageType(key) {
    var pageTypeMap = {
      ProductDisplay: 'PP-PIP',
      ProductDisplayChanel: 'PP-CPIP',
      BundleDisplay: 'PP-BUN',
      BundleDisplayChanel: 'PP-CBUN',
      OutfitDisplay: 'PP-BUN',
      OutfitComponent: '',
      ProductItemAttrDisplay: 'PP-PIA',
      ProductItemDisplay: 'PP-PIL',
      ProductItemDisplayChanel: 'PP-CPIL',
      ProductDisplayEcard: 'PP-PIP',
      QuickViewDisplay: 'PP-QV',
      QuickViewNotAvailable: 'PP-QV-NA',
      NotAvailable: 'PP-NA',
      OldProduct: 'PP-PB',
      QuickViewOldProduct: 'PP-PV-PB',
    };
    return pageTypeMap[key];
  }
  //	shouldComponentUpdate(nextProps, nextState){
  //		return this.props.contentData.navState != nextProps.contentData.navState;
  //	}
  UNSAFE_componentWillReceiveProps(nextProps) {
    prevItem = '';
    prevItem2 = '';
    prevItem3 = '';
    if (document.getElementsByClassName('AddtoCartModal').length === 0) {
      //if mix and match stylitics widget and modal is open, lock the background
      if (
        typeof ddsStyliticsWidgetInstance !== 'undefined' &&
        ddsStyliticsWidgetInstance.widgetVisibility &&
        ddsStyliticsWidgetInstance.widgetVisibility.experiences &&
        ddsStyliticsWidgetInstance.widgetVisibility.experiences.formatted &&
        ddsStyliticsWidgetInstance.widgetVisibility.experiences.formatted.mixAndMatch &&
        ddsStyliticsWidgetInstance.widgetVisibility.experiences.formatted.mixAndMatch === true &&
        document.getElementById('dds-stylitics-widget') &&
        document
          .getElementById('dds-stylitics-widget')
          .querySelector('.stylitics-desktop-modal-close, .stylitics-close, .stylitics-modal')
      ) {
        try {
          if (document.querySelector('body').classList.value.indexOf('ReactModal__Body--open') === -1) {
            document.getElementsByTagName('body')[0].style.overflowY = 'hidden';
          } else {
            var isDdsModalClosed = setInterval(function () {
              if (document.querySelector('body').classList.value.indexOf('ReactModal__Body--open') === -1) {
                document.getElementsByTagName('body')[0].style.overflowY = 'hidden';
                clearInterval(isDdsModalClosed);
              }
            }, 250);
            setTimeout(function () {
              clearInterval(isDdsModalClosed);
            }, 5000);
          }
        } catch (e) {
          console.log(e);
        }
      } else {
        //classic stylitics widget
        if ($('.stylitics-close').length == 0) {
          //modal closed
          $('.stylitics-sequence-scroll-snap').css('overflow-x', 'scroll');
          $('body').css('overflow', '');
        } else if ($('.mobilePage').length > 0) {
          //modal open and on mobile
          $('.stylitics-sequence-scroll-snap').css('overflow-x', 'hidden');
          $('body').css('overflow', 'hidden');
        }
      }
    }

    var callStylitics = false;
    if (
      nextProps.contentData.productId &&
      (this.props.contentData.productId != nextProps.contentData.productId ||
        this.props.contentData.salePage != nextProps.contentData.salePage ||
        this.props.contentData.productLayout != nextProps?.contentData.productLayout)
    ) {
      this.state.checkForErrors = false;
      this.state.selectedMainImg = '';
      this.state.wlResponse = false;
      this.resetFreqRecieveProps();
      this.setDefaultImageByURLParam(
        this.props.passedAppFunctions.getURLParamValue('df'),
        this.props.passedAppFunctions.getURLParamValue('di'),
        nextProps
      );
      this.state.liveReviewCount = false;
      this.state.liveReviewStars = false;
      this.state.liveQuestionAnswerCount = false;
      this.state.itemPriceInfo = undefined;
      this.initializeStateObjects(nextProps.contentData);
      this.getProductImagesArray(nextProps.contentData);
      this.updateDataLayer(nextProps);
      this.automationExpose(nextProps);
      this.personalizationTracking(1);
      callStylitics = true;
    } else {
      if (
        typeof window != 'undefined' &&
        window.injectedAttributeStateFunction &&
        this.state.attributeState &&
        this.props.contentData[`onSaleInfo_${this.props.contentData.productId}`] &&
        this.props.contentData[`onSaleInfo_${this.props.contentData.productId}`].onSaleItemMap &&
        this.props.contentData.pricing
      ) {
        this.state.attributeState = window.injectedAttributeStateFunction(
          JSON.parse(JSON.stringify(this.state.attributeState)),
          this.props.contentData[`onSaleInfo_${this.props.contentData.productId}`].onSaleItemMap,
          this.props.contentData.pricing
        );
      }
      if (
        this.state.countryCookieUndefined == true &&
        $('#dds-stylitics-widget-container').children() &&
        $('#dds-stylitics-widget-container').children().length == 0
      ) {
        callStylitics = true;
      }
    }
    // Need to double check with Ben if Stylitics is still working as expected
    if (callStylitics) {
      var pid = '',
        colorName = '',
        potentialColorName = '';
      if (nextProps && nextProps.contentData && nextProps.contentData.fullImage) {
        potentialColorName =
          nextProps.contentData.navState && nextProps.contentData.navState.indexOf('df=') > -1
            ? nextProps.contentData.navState.split('df=')[1]
            : '';
        pid = nextProps.contentData.partNumber ? nextProps.contentData.partNumber : '';

        var selectedMainImg = nextProps.contentData.fullImage.imageNameNoPath
          ? nextProps.contentData.fullImage.imageNameNoPath
          : '';
        var altImages = nextProps.contentData.altImages ? nextProps.contentData.altImages : [];
        if (
          altImages.length == 0 &&
          nextProps.contentData.swatchGroups &&
          nextProps.contentData.swatchGroups[0] &&
          nextProps.contentData.swatchGroups[0].swatches &&
          nextProps.contentData.swatchGroups[0].swatches[0]
        ) {
          if (selectedMainImg === nextProps.contentData.swatchGroups[0].swatches[0].fullImage) {
            colorName = nextProps.contentData.swatchGroups[0].swatches[0].colorForSwatch;
          }
        } else {
          var colorFound = false,
            potentialColorMathed = false;
          for (var thisAlt of altImages) {
            if (
              thisAlt.altText &&
              thisAlt.imageName &&
              thisAlt.imageName.indexOf(selectedMainImg) > -1 &&
              !colorFound &&
              !potentialColorMathed
            ) {
              colorName = thisAlt.altText.split('Color:').join('').split(' - ')[0];
              colorFound = true;
            }
            if (thisAlt.altText && !potentialColorMathed) {
              var thisColor = thisAlt.altText.split('Color:').join('').split(' - ')[0];
              if (thisColor.toLowerCase() === potentialColorName.split('-').join(' ')) {
                colorName = potentialColorName;
                potentialColorMathed = true;
                colorFound = true;
              }
            }
          }
        }
        this.populateDdsStyliticsWidgetInstance(this.formatColorWay(pid, colorName));
      }
    }

    this.checkVideoChat();
  }

  getAttrId(imgName, contentData) {
    const newImgName = imgName?.split('_ai')[0]?.split('__')[0];
    const itemObject = contentData?.skus?.find((item) => {
      if (newImgName?.includes(item?.fullImage)) {
        prevItem = item;
        return item;
      } else return prevItem;
    });
    if (itemObject?.definingAttributes?.length > 0) {
      const colorAttrObj = itemObject.definingAttributes.find((a) => a.name === 'Color');
      if (colorAttrObj?.id) {
        return colorAttrObj.id;
      }
    }
    return 'no-id';
  }

  getAttrName(imgName, contentData) {
    const newImgName = imgName?.split('_ai')[0]?.split('__')[0];
    const trimmedName = newImgName?.split('_zi_')[1];
    const itemObject = contentData?.skus?.find((item) => {
      const trimmedItemImgName = item.fullImage.split('_zi_')[1];
      return trimmedName == trimmedItemImgName;
    });

    if (
      (itemObject?.definingAttributes?.length > 0 && itemObject?.definingAttributes.find((a) => a.name === 'Color')) ||
      typeof prevItem2 == 'object'
    ) {
      let colorAttrObj = '';
      if (
        itemObject?.definingAttributes?.length > 0 &&
        itemObject?.definingAttributes.find((a) => a.name === 'Color')
      ) {
        colorAttrObj = itemObject.definingAttributes.find((a) => a.name === 'Color');
        prevItem2 = itemObject.definingAttributes.find((a) => a.name === 'Color');
      } else {
        colorAttrObj = prevItem2;
      }
      return colorAttrObj?.value?.value;
    }
    return 'no-color';
  }

  getAttrType(imgName, contentData) {
    const newImgName = imgName?.split('_ai')[0]?.split('__')[0];
    const itemObject = contentData?.skus?.find((item) => newImgName?.includes(item?.fullImage));

    if (
      (itemObject?.definingAttributes?.length > 0 && itemObject?.definingAttributes.find((a) => a.name === 'Color')) ||
      typeof prevItem3 == 'object'
    ) {
      let colorAttrObj = '';
      if (
        itemObject?.definingAttributes?.length > 0 &&
        itemObject?.definingAttributes.find((a) => a.name === 'Color')
      ) {
        colorAttrObj = itemObject.definingAttributes.find((a) => a.name === 'Color');
        prevItem3 = itemObject.definingAttributes.find((a) => a.name === 'Color');
      } else {
        colorAttrObj = prevItem3;
      }
      // needed for stylitics
      return 'Color';
    }
    return 'no-color';
  }

  getProductImagesArray(contentData) {
    const altImagesToUse = JSON?.parse(JSON?.stringify(contentData?.altImages || []));

    // loop through skus and reduce to simple list of colors
    let colorsArray = [];
    if (contentData.swatchGroups) {
      colorsArray = contentData.skus?.reduce((accum, skuItem) => {
        const colorAttr = skuItem.definingAttributes.find((a) => a.name == 'Color');
        if (!accum.includes(colorAttr?.value.value)) {
          accum.push(colorAttr?.value.value);
        }
        return accum;
      }, []);
    }

    // grab all main images from the skus (fullImage represents the main image and repeats for each color)
    // items with 3 attributes, i.e. "narrow calf, standard calf, wide calf" have main images for each type
    const mainImgArr = contentData.skus?.reduce((acc, item) => {
      if (!acc?.includes(item.fullImage)) {
        acc.push(item.fullImage);
      }
      return acc;
    }, []);

    let dataKeyCounter = 0;
    let newArray = [];
    if (colorsArray?.length > 0 && colorsArray[0] !== undefined) {
      newArray = colorsArray.flat().map((color, idx) => {
        let counter = 1;
        const filteredArray = [];

        if (altImagesToUse.length > 0) {
          altImagesToUse.map((a) => {
            if (this.getAttrName(a.imageName, contentData) === color) {
              // for items with more main images than colors, it probably means it has a main image for each special attribute (wide, standard, narrow)
              if (mainImgArr.length > colorsArray.length && counter == 1) {
                const filteredMainImages = mainImgArr.reduce((acc, item) => {
                  if (!acc.includes(item) && this.getAttrName(item, contentData) === color) {
                    acc.push(item);
                  }
                  return acc;
                }, []);

                filteredMainImages.map((item) => {
                  const newMainImgObj = {
                    altText: `Color: ${color} - Image ${counter} - ${contentData.productName}`,
                    altColor: color,
                    imageName: item,
                    dataKey: dataKeyCounter,
                  };
                  counter++;
                  dataKeyCounter++;
                  filteredArray.push(newMainImgObj);
                });
              }

              //WWW-21543 Check if altimages has a main image/if not add one
              if (counter == 1) {
                if (a.imageName.includes(mainImgArr[idx])) {
                  const newAttObj = {
                    altText: `Color: ${color} - Image ${counter} - ${contentData.productName}`,
                    imageName: mainImgArr[idx],
                    altColor: color,
                    dataKey: dataKeyCounter,
                  };
                  counter++;
                  dataKeyCounter++;
                  filteredArray.push(newAttObj);
                } else {
                  if (!filteredArray.includes(mainImgArr[idx])) {
                    const newAttObj = {
                      altText: `Color: ${color} - Image ${counter} - ${contentData.productName}`,
                      imageName: mainImgArr[idx],
                      altColor: color,
                      dataKey: dataKeyCounter,
                    };
                    counter++;
                    dataKeyCounter++;
                    filteredArray.push(newAttObj);
                  }
                }
              }

              // if "a" is not the main image, add to array
              if (!mainImgArr.includes(a.imageName)) {
                const newObj = { ...a };
                newObj.altText = `Color: ${color} - Image ${counter} - ${contentData.productName}`;
                newObj.altColor = color;
                (newObj.dataKey = dataKeyCounter), counter++;
                dataKeyCounter++;
                filteredArray.push(newObj);
              }
            }
          });
        } else {
          filteredArray.push({
            altText: contentData.productName,
            dataKey: 0,
            imageName: this.state.selectedMainImg,
          });
        }
        return filteredArray.filter((a) => a !== undefined).flat();
      });
    } else {
      let counter = 1;

      const filteredArray = [];

      altImagesToUse.map((a) => {
        const newObj = { ...a };
        newObj.altText = `Color: ${contentData.productName} - Image ${counter} - ${contentData.productName}`;
        newObj.dataKey = counter - 1;
        counter++;
        filteredArray.push(newObj);
      });

      newArray = filteredArray.filter((a) => a !== undefined).flat();
    }

    //In case there are no main images for the specific color
    let strippedArr = newArray.filter((val) => val.length !== 0);

    this.setState({ productImagesArray: strippedArr.flat() });
  }

  updateLiveReviewCounts(liveReviewCount, liveReviewStars) {
    //TODO optimize so it does not cause extra renders!!!!!!
    // if (
    // 	(liveReviewCount != this.state.liveReviewCount && liveReviewCount != this.props.contentData.reviewCount) ||
    // 	(liveReviewStars != this.state.liveReviewStars && liveReviewStars != this.props.contentData.reviewStars)
    // ) {
    // 	this.setState({ liveReviewCount: liveReviewCount, liveReviewStars: liveReviewStars });
    // }

    this.setState({ liveReviewCount: liveReviewCount, liveReviewStars: liveReviewStars });
  }
  updateLiveQuestionAnswersCount(liveQuestionAnswerCount) {
    //TODO optimize so it does not cause extra renders!!!!!!
    if (
      liveQuestionAnswerCount != this.state.liveQuestionAnswerCount &&
      liveQuestionAnswerCount != this.props.contentData.questionAnswerCount
    ) {
      this.setState({ liveQuestionAnswerCount: liveQuestionAnswerCount });
    }
  }
  resetFreqRecieveProps = () => {
    this.updateSubscriptionFrequency('');
    var onceRadio = document.querySelector("input[name=subFrequencyRadio][value='once']");
    if (onceRadio != undefined) {
      onceRadio.checked = true;
    }
    var freqEl = document.querySelector(
      `#subscription-section select#subFrequencySelect__${this.props.contentData.partNumber}`
    );
    if (freqEl !== null) {
      if (freqEl.value == 'subscribe') {
        var options = freqEl.options;
        for (var i = 0; i < options.length; i++) {
          var option = options[i];
          if (option.value == '') {
            freqEl.removeChild(option);
          }
        }
        freqEl.disabled = false;
      } else {
        freqEl.appendChild(new Option('Select Frequency', ''));
        freqEl.value = '';
        freqEl.disabled = true;
      }
    }
  };
  resetFreqOnMount = () => {
    this.updateSubscriptionFrequency('');
    var onceRadio = document.querySelector("input[name=subFrequencyRadio][value='once']");
    if (onceRadio != undefined) {
      onceRadio.checked = true;
    }
    var freqEl = document.querySelector('#subscription-section select[name="subFrequencySelect"]');
    if (freqEl !== null) {
      if (freqEl.value !== '') {
        freqEl.appendChild(new Option('Select Frequency', ''));
        freqEl.value = '';
        freqEl.disabled = true;
      }
    }
  };

  updateSubscriptionFrequency = (freq) => {
    this.setState({
      subscriptionFrequency: freq,
    });
  };

  shouldShowFreeShipping() {
    if (this.props.contentData.unavailableMessage) {
      returnBoolean = false;
    } else {
      var activePricingObject = this.willHaveFlatAttribute()
        ? this.flatSizesPriceObject()
        : this.props.contentData.pricing;
      var returnBoolean = false;
      var freeShippingThreshold = (this.props.contentData.freeShippingThreshold || 150) * 1;
      var isSpecialShipping = this.props.contentData.dil_calcodeIds;
      var isNoPreviewSaleDay =
        this.props.passedAppFunctions.wasParms.isSaleDay == 'true' &&
        this.props.passedAppFunctions.wasParms.isPreviewDay == 'false';
      var originalPricingObject = this.props.contentData.pricing;
      var calcodes = this.props.contentData.dil_calcodeIds;
      if (isNoPreviewSaleDay) {
        returnBoolean = false;
      } else {
        //this product has no marked down items and the active flat size group has no sale items
        if (
          activePricingObject.offerPriceMin.split(',').join('') * 1 >= freeShippingThreshold &&
          activePricingObject.offerPriceMax.split(',').join('') * 1 >= freeShippingThreshold
        ) {
          returnBoolean = true;
        }
      }
      if (isSpecialShipping == 'true') {
        returnBoolean = false;
      }
      return returnBoolean;
    }
  }

  willHaveFlatAttribute() {
    var returnBoolean = false;
    Object.values(this.state.attributesMain ?? [])?.forEach((attr) => {
      if (attr.displayStyle === 'flat' || attr.displayStyle === 'Flat') returnBoolean = true;
    });

    return returnBoolean;
  }

  updateDataLayer = (passedProps) => {
    var pageType = '';
    try {
      pageType =
        passedProps.passedAppFunctions &&
        passedProps.passedAppFunctions.linkToState &&
        passedProps.passedAppFunctions.linkToState.stylitics
          ? 'PP-QV-H2W'
          : this.getPageType(passedProps.contentData.productLayout);
    } catch (e) {
      console.log(e);
    }
    var pageIdVal = '';

    let productListItems = [];

    var actualBreadCrumb = '';
    var actualBreadCrumbId = '';
    var primaryCategory = '';
    var primaryCategoryId = '';
    var availableForPurchase =
      passedProps.contentData.productLayout.indexOf('BadCatentryId') > -1 ||
      passedProps.contentData.productLayout.indexOf('NotAvailable') > -1 ||
      passedProps.contentData.productLayout.indexOf('OldProduct') > -1 ||
      (passedProps.contentData.unavailableMessage &&
        passedProps.contentData.unavailableMessage ===
          'This item is not currently available for purchase on Dillards.com')
        ? 'N'
        : 'Y';

    if (passedProps.contentData.productLayout != 'OutfitComponent') {
      if (
        passedProps.passedAppFunctions.linkToState.actualBreadCrumb &&
        passedProps.passedAppFunctions.linkToState.actualBreadCrumb.length &&
        passedProps.passedAppFunctions.linkToState.actualBreadCrumb[0].breadcrumbValue
      ) {
        actualBreadCrumb =
          passedProps.passedAppFunctions.linkToState.actualBreadCrumb[0].breadcrumbValue
            .split('&#039;')
            .join("'")
            .split('&amp;')
            .join('&') || ' ';
        actualBreadCrumbId = passedProps.passedAppFunctions.linkToState.actualBreadCrumb[0].breadcrumbCatId;
      }
      primaryCategory =
        passedProps.contentData && passedProps.contentData.superCat && passedProps.contentData.superCat != ''
          ? passedProps.contentData.superCat.split('&#039;').join('')
          : actualBreadCrumb && actualBreadCrumb != ''
            ? actualBreadCrumb
            : '';
      primaryCategoryId =
        passedProps.contentData &&
        passedProps.contentData.personalization &&
        passedProps.contentData.personalization.superCatId &&
        passedProps.contentData.personalization.superCatId != ''
          ? passedProps.contentData.personalization.superCatId
          : actualBreadCrumbId && actualBreadCrumbId != ''
            ? actualBreadCrumbId
            : '';
    }

    if (
      passedProps.contentData.productLayout == 'BundleDisplay' ||
      passedProps.contentData.productLayout == 'OutfitDisplay' ||
      passedProps.contentData.productLayout == 'BundleDisplayChanel'
    ) {
      //In here we will do the loop through the product info:
      var thisBundleDataLayerObject = {};
      thisBundleDataLayerObject.name = passedProps.contentData.originalProductName;
      thisBundleDataLayerObject.partNumber = passedProps.contentData.partNumber;
      thisBundleDataLayerObject.catentryId = passedProps.contentData.productId;
      thisBundleDataLayerObject.DMS = '||';
      thisBundleDataLayerObject.isQuickView = passedProps.contentData.productLayout.indexOf('Quick') > -1 ? 'Y' : 'N';
      thisBundleDataLayerObject.availableForPurchase = availableForPurchase;
      thisBundleDataLayerObject.categoryId =
        passedProps.passedAppFunctions.getURLParamValue('categoryId') ||
        passedProps.passedAppFunctions.linkToState.categoryId ||
        '-10035';
      thisBundleDataLayerObject.pageType = pageType;

      thisBundleDataLayerObject.bundleProducts = [];
      for (var iProducts = 0; iProducts < passedProps.contentData.components.length; iProducts++) {
        var thisProductData = passedProps.contentData.components[iProducts];
        var newProductInfo = {};

        newProductInfo.name = thisProductData.originalProductName;
        newProductInfo.partNumber = thisProductData.partNumber;
        newProductInfo.catentryId = thisProductData.productId;
        newProductInfo.limitedAvailability = thisProductData.limitedAvailability ? 'Y' : 'N';
        newProductInfo.brand = thisProductData.brandNameForTitle;
        if (!thisBundleDataLayerObject.brand) thisBundleDataLayerObject.brand = thisProductData.brandNameForTitle;
        newProductInfo.DMS = `${thisProductData.dept}|${thisProductData.mic}|${thisProductData.style}`;
        newProductInfo.availableForPurchase = availableForPurchase;
        newProductInfo.categoryId = thisBundleDataLayerObject.categoryId;
        newProductInfo.itemInfo = thisProductData.itemInfo;
        newProductInfo.offerPriceMax = thisProductData.pricing.offerPriceMax;
        newProductInfo.offerPriceMin = thisProductData.pricing.offerPriceMin;
        newProductInfo.offerPriceRange = thisProductData.pricing.offerPriceRange;
        thisBundleDataLayerObject.DMS = newProductInfo.DMS;

        if (thisProductData.reviews && thisProductData.reviews.numOfReviews && thisProductData.reviews.numOfStars) {
          newProductInfo.starRating = thisProductData.reviews.numOfStars;
          newProductInfo.numberOfReviews = thisProductData.reviews.numOfReviews;
        }

        thisBundleDataLayerObject.bundleProducts.push(newProductInfo);

        //datalayer for analytics
        let productListItem = {};
        productListItem.name =
          newProductInfo !== undefined && newProductInfo.name !== undefined
            ? newProductInfo.name
                .split('#double;')
                .join('"')
                .split('-')
                .join(' ')
                .replace(/[^a-zA-Z 0-9\&]/g, '')
            : '404';
        productListItem.SKU = newProductInfo.partNumber;
        productListItem.priceTotal = thisProductData.pricing.offerPriceMin;
        productListItem.quantity = ' ';

        let _additionalVars = {};
        _additionalVars.DMS =
          newProductInfo.DMS == 'undefined|undefined|undefined'
            ? '0000:000:0000'
            : newProductInfo.DMS.split('|').join(':');
        _additionalVars.availableForPurchase = availableForPurchase;
        _additionalVars.brand = newProductInfo.brand;
        _additionalVars.categoryId = newProductInfo.categoryId;
        _additionalVars.catentryId = newProductInfo.catentryId;
        _additionalVars.pageType = thisBundleDataLayerObject.pageType;
        _additionalVars.isQuickView = thisBundleDataLayerObject.isQuickView;
        _additionalVars.limitedAvailability = newProductInfo.limitedAvailability;
        _additionalVars.offerPriceMax = thisProductData.pricing.offerPriceMax;
        _additionalVars.offerPriceMin = thisProductData.pricing.offerPriceMin;
        _additionalVars.offerPriceRange = thisProductData.pricing.offerPriceRange;
        _additionalVars.partNumber = newProductInfo.partNumber;
        _additionalVars.primaryCategory = primaryCategory;
        _additionalVars.primaryCategoryId = primaryCategoryId;

        productListItem._additionalVars = _additionalVars;
        productListItems.push(productListItem);
      }

      if (passedProps.passedAppFunctions.getURLParamValue('singleProductResult')) {
        thisBundleDataLayerObject.singleProductResult =
          passedProps.passedAppFunctions.getURLParamValue('singleProductResult');
      }

      passedProps.passedAppFunctions.setDataLayerInfo('product', thisBundleDataLayerObject);

      passedProps.passedAppFunctions.setDataLayerInfo('commerce', { productViews: { value: 1 } });
      passedProps.passedAppFunctions.setDataLayerInfo('productListItems', productListItems);

      if (passedProps.passedAppFunctions.getURLParamValue('singleProductResult')) {
        realSearchVal = 'Y';
        pageIdVal = 'SEARCH: Results Successful';
        searchTermVal = passedProps.passedAppFunctions.getURLParamValue('singleProductResult');
        searchCountVal = '1';
        searchTermVal = passedProps.passedAppFunctions.getURLParamValue('singleProductResult');
        searchCountVal = '1';
        searchTermVal = passedProps.passedAppFunctions.getURLParamValue('singleProductResult');
        searchCountVal = '1';
      } else {
        realSearchVal = 'N';
        pageIdVal = 'Product:' + passedProps.contentData.partNumber + ':' + passedProps.contentData.originalProductName;
      }
    } else if (passedProps.contentData.productLayout != 'OutfitComponent') {
      //need this for everything except bundle/outfit pages
      var thisProductDataLayerObject = {};
      thisProductDataLayerObject.name = passedProps.contentData.originalProductName;
      thisProductDataLayerObject.partNumber = passedProps.contentData.partNumber;
      thisProductDataLayerObject.catentryId = passedProps.contentData.productId;
      thisProductDataLayerObject.limitedAvailability = passedProps.contentData.limitedAvailability ? 'Y' : 'N';
      thisProductDataLayerObject.brand = passedProps.contentData.brandNameForTitle;
      thisProductDataLayerObject.DMS = `${passedProps.contentData.dept}|${passedProps.contentData.mic}|${passedProps.contentData.style}`;
      thisProductDataLayerObject.isQuickView = passedProps.contentData.productLayout.indexOf('Quick') > -1 ? 'Y' : 'N';
      thisProductDataLayerObject.availableForPurchase = availableForPurchase;
      thisProductDataLayerObject.categoryId =
        passedProps.passedAppFunctions.getURLParamValue('categoryId') ||
        passedProps.passedAppFunctions.linkToState.categoryId ||
        '-10035';
      thisProductDataLayerObject.pageType = pageType;
      if (passedProps.contentData.productLayout.indexOf('Quick') > -1) {
        if (passedProps.contentData.extraQVProps && passedProps.contentData.extraQVProps.OSS) {
          thisProductDataLayerObject.pageType = thisProductDataLayerObject.pageType + '-OSS';
        }
        if (passedProps.contentData.extraQVProps && passedProps.contentData.extraQVProps.collection) {
          thisProductDataLayerObject.pageType = thisProductDataLayerObject.pageType + '-SC';
        }
        if (
          passedProps.contentData.additionalSizes &&
          passedProps.passedAppFunctions.linkToState &&
          passedProps.passedAppFunctions.linkToState.addSizeAttribute
        ) {
          thisProductDataLayerObject.pageType = thisProductDataLayerObject.pageType + '-AS';
          thisProductDataLayerObject.addSizeAttribute = passedProps.passedAppFunctions.linkToState.addSizeAttribute;
        }
      }

      if (
        passedProps.contentData.reviews &&
        passedProps.contentData.reviews.numOfReviews &&
        passedProps.contentData.reviews.numOfStars
      ) {
        thisProductDataLayerObject.starRating = passedProps.contentData.reviews.numOfStars;
        thisProductDataLayerObject.numberOfReviews = passedProps.contentData.reviews.numOfReviews;
      }
      if (passedProps.contentData.pricing) {
        thisProductDataLayerObject.offerPriceMin = passedProps.contentData.pricing.offerPriceMin;
        thisProductDataLayerObject.offerPriceMax = passedProps.contentData.pricing.offerPriceMax;
        thisProductDataLayerObject.offerPriceRange = passedProps.contentData.pricing.offerPriceRange;
      }
      var realSearchVal = '';
      var searchTermVal = '';
      var searchCountVal = '';
      // var searchTermVal = '';
      // var searchCountVal = '';
      // var searchTermVal = '';
      // var searchCountVal = '';
      if (passedProps.passedAppFunctions.getURLParamValue('singleProductResult')) {
        thisProductDataLayerObject.singleProductResult =
          passedProps.passedAppFunctions.getURLParamValue('singleProductResult');
        realSearchVal = 'Y';
        pageIdVal = 'SEARCH: Results Successful';
        searchTermVal = passedProps.passedAppFunctions.getURLParamValue('singleProductResult');
        searchCountVal = '1';
        searchTermVal = passedProps.passedAppFunctions.getURLParamValue('singleProductResult');
        searchCountVal = '1';
        searchTermVal = passedProps.passedAppFunctions.getURLParamValue('singleProductResult');
        searchCountVal = '1';
      } else {
        realSearchVal = 'N';
        pageIdVal = 'Product:' + passedProps.contentData.partNumber + ':' + passedProps.contentData.originalProductName;
      }

      var trackingForAB = this.searchABTracking();
      if (trackingForAB && trackingForAB.length > 0) {
        thisProductDataLayerObject.fromSearchPage = 'Y';
        if (trackingForAB.indexOf('UB') > -1) {
          thisProductDataLayerObject.fromUBSearchPage = 'Y';
        }
      }

      let productListItem = {};
      productListItem.name =
        thisProductDataLayerObject !== undefined && thisProductDataLayerObject.name !== undefined
          ? thisProductDataLayerObject.name
              .split('#double;')
              .join('"')
              .split('-')
              .join(' ')
              .replace(/[^a-zA-Z 0-9\&]/g, '')
          : '404';
      productListItem.SKU = thisProductDataLayerObject.partNumber;
      productListItem.priceTotal = thisProductDataLayerObject.offerPriceMin;
      productListItem.quantity = ' ';

      let _additionalVars = {};
      _additionalVars.DMS =
        thisProductDataLayerObject.DMS == 'undefined|undefined|undefined'
          ? '0000:000:0000'
          : thisProductDataLayerObject.DMS.split('|').join(':');
      _additionalVars.availableForPurchase = availableForPurchase;
      _additionalVars.brand = thisProductDataLayerObject.brand;
      _additionalVars.categoryId = thisProductDataLayerObject.categoryId;
      _additionalVars.catentryId = thisProductDataLayerObject.catentryId;
      _additionalVars.pageType = thisProductDataLayerObject.pageType;
      _additionalVars.isQuickView = thisProductDataLayerObject.isQuickView;
      _additionalVars.limitedAvailability = thisProductDataLayerObject.limitedAvailability;
      _additionalVars.offerPriceMax = thisProductDataLayerObject.offerPriceMax;
      _additionalVars.offerPriceMin = thisProductDataLayerObject.offerPriceMin;
      _additionalVars.offerPriceRange = thisProductDataLayerObject.offerPriceRange;
      _additionalVars.partNumber = thisProductDataLayerObject.partNumber;
      _additionalVars.primaryCategory = primaryCategory;
      _additionalVars.primaryCategoryId = primaryCategoryId;

      productListItem._additionalVars = _additionalVars;
      productListItems.push(productListItem);

      passedProps.passedAppFunctions.setDataLayerInfo('commerce', { productViews: { value: 1 } });
      passedProps.passedAppFunctions.setDataLayerInfo('productListItems', productListItems);
      passedProps.passedAppFunctions.setDataLayerInfo('product', thisProductDataLayerObject);
      passedProps.passedAppFunctions.setDataLayerInfo('itemInfo', passedProps.contentData.itemInfo);
    }

    if (passedProps.contentData.productLayout != 'OutfitComponent') {
      var subCategory1 = '';
      var subCategory2 = '';
      var subCategoryId1 = '';
      var subCategoryId2 = '';
      var searchPosition = '';
      var realSearch = '';
      var searchResultsClicked = '';

      if (passedProps.passedAppFunctions.linkToState.realSearch) {
        realSearch = passedProps.passedAppFunctions.linkToState.realSearch || 'N';
        searchResultsClicked = 'Y';
      }
      if (passedProps.passedAppFunctions.linkToState.searchPosition)
        searchPosition = passedProps.passedAppFunctions.linkToState.searchPosition + 1 + '';
      if (
        passedProps.passedAppFunctions.linkToState.actualBreadCrumb &&
        passedProps.passedAppFunctions.linkToState.actualBreadCrumb.length &&
        passedProps.passedAppFunctions.linkToState.actualBreadCrumb[0].breadcrumbValue
      ) {
        if (passedProps.passedAppFunctions.linkToState.actualBreadCrumb.length > 1) {
          subCategory1 =
            passedProps.passedAppFunctions.linkToState.actualBreadCrumb[1].breadcrumbValue
              .split('&#039;')
              .join("'")
              .split('&amp;')
              .join('&') || '';
          subCategoryId1 = passedProps.passedAppFunctions.linkToState.actualBreadCrumb[1].breadcrumbCatId;
        }
        if (passedProps.passedAppFunctions.linkToState.actualBreadCrumb.length > 2) {
          subCategory2 =
            passedProps.passedAppFunctions.linkToState.actualBreadCrumb[2].breadcrumbValue
              .split('&#039;')
              .join("'")
              .split('&amp;')
              .join('&') || '';
          subCategoryId2 = passedProps.passedAppFunctions.linkToState.actualBreadCrumb[2].breadcrumbCatId;
        }
      }
      passedProps.passedAppFunctions.setDataLayerInfo('page', {
        RealSearch: realSearchVal || realSearch || 'N',
        name: passedProps.contentData.originalProductName,
        pageId: pageIdVal || '',
        categoryId:
          passedProps.passedAppFunctions.getURLParamValue('categoryId') ||
          passedProps.passedAppFunctions.linkToState.categoryId ||
          '-10035',
        type: 'Product',
        searchTerm: searchTermVal || '',
        searchResultsCount: searchCountVal || '',
        primaryCategory:
          passedProps.contentData && passedProps.contentData.superCat && passedProps.contentData.superCat != ''
            ? passedProps.contentData.superCat.split('&#039;').join('')
            : actualBreadCrumb && actualBreadCrumb != ''
              ? actualBreadCrumb
              : '',
        primaryCategoryId:
          passedProps.contentData &&
          passedProps.contentData.personalization &&
          passedProps.contentData.personalization.superCatId &&
          passedProps.contentData.personalization.superCatId != ''
            ? passedProps.contentData.personalization.superCatId
            : actualBreadCrumbId && actualBreadCrumbId != ''
              ? actualBreadCrumbId
              : '',
        subCategory1: subCategory1 || '',
        subCategoryId1: subCategoryId1 || '',
        subCategory2: subCategory2 || '',
        searchPosition: searchPosition || '',
        subCategoryId2: subCategoryId2 || '',
        searchResultsClicked: searchResultsClicked || '',
      });
    }
    if (this.props.contentData.productLayout == 'BadCatentryId') {
      passedProps.passedAppFunctions.setDataLayerInfo('page', {
        RealSearch: realSearchVal || 'N',
        name: passedProps.contentData.originalProductName,
        pageId: pageIdVal || '',
        categoryId: '-10050',
        type: 'Product',
        searchTerm: searchTermVal || '',
        searchResultsCount: searchCountVal || '',
      });
      passedProps.passedAppFunctions.setDataLayerInfo('product', {
        categoryId: '-10050',
        availableForPurchase: 'N',
      });
    }
    if (
      passedProps.passedAppFunctions &&
      passedProps.passedAppFunctions.fromQv &&
      passedProps.passedAppFunctions.fromQv == true
    ) {
      try {
        $(document).trigger('triggerPageView');
      } catch (e) {}
      passedProps.passedAppFunctions.triggerCustomPageView();
    }
  };
  automationExpose(nextProps) {
    try {
      if (nextProps) {
        this.automationUnexpose();
      }
      window.productPageExpose = window.productPageExpose || {};
      if (
        this.props.contentData.productLayout != 'BundleDisplay' &&
        this.props.contentData.productLayout != 'OutfitDisplay' &&
        this.props.contentData.productLayout != 'BundleDisplayChanel'
      ) {
        window.productPageExpose[`updateAttributeState2${this.props.contentData.productId}`] =
          this.updateAttributeState2;
        window.productPageExpose[`attributeState${this.props.contentData.productId}`] = JSON.parse(
          JSON.stringify(this.state.attributeState)
        );
      }
    } catch (e) {
      //do nothing...
    }
  }
  automationUnexpose(prevProps) {
    try {
      var propsToUse = prevProps || this.props;
      if (window.productPageExpose[`updateAttributeState2${propsToUse.contentData.productId}`]) {
        delete window.productPageExpose[`updateAttributeState2${propsToUse.contentData.productId}`];
        delete window.productPageExpose[`attributeState${propsToUse.contentData.productId}`];
      }
    } catch (e) {
      //do nothing...
    }
  }

  focusFirstAttrError(el) {
    if (
      this.state.checkForErrors == true &&
      this.props.passedAppFunctions.quickviewIsOpen == false &&
      this.props.contentData.productLayout !== 'OutfitComponent'
    ) {
      const erroredAttrs = document.getElementsByClassName('selectHasError');
      if (erroredAttrs.length > 0) {
        let offsetTop = 150;
        let firstErroredAttr = erroredAttrs[0].getBoundingClientRect().top;
        let offsetPos = firstErroredAttr + window.scrollY - offsetTop;
        window.scrollTo({
          top: offsetPos,
          behavior: 'smooth',
        });
        try {
          if (el != undefined) {
            window.scrollTo({
              top: offsetPos,
              behavior: 'smooth',
            });
          }
        } catch (e) {}
      }
      // For quickview display
    } else {
      if (this.state.checkForErrors == true && this.props.passedAppFunctions.quickviewIsOpen == true) {
        const focusModalError = document.querySelectorAll('qvSelectHasError');
        if (focusModalError.length > 0) {
          focusModalError[0].scrollIntoView({ behavior: 'smooth' });
        }
      }
    }
  }

  componentDidUpdate(prevProps) {
    this.state.possibleIncorrectProductId = false;
    if (prevProps.contentData.productId && prevProps.contentData.productId !== this.props.contentData.productId) {
      Object.keys(this.state.currentAttributeState).map((selVal) => {
        this.state.currentAttributeState[selVal].selectedValue = undefined;
      });
      this.state.currentAttributeState = { ...this.state.currentAttributeState };

      if (
        this.props.passedAppFunctions.siteFormat == 'desktop' &&
        this.props.contentData.productLayout == 'ProductDisplay' &&
        this.props.passedAppFunctions.quickviewIsOpen == false
      ) {
        this.checkMainImageLoad();
      }
    }

    if ($('#root').css('position') === 'relative') $('#root').css('position', '');
    try {
      if (
        prevProps.contentData.productId != this.props.contentData.productId ||
        prevProps.contentData.salePage != this.props.contentData.salePage
      ) {
        this.automationUnexpose(prevProps);
      }
      this.automationExpose();
    } catch (e) {
      //do nothing...
    }

    if ($('#invalidComboContainer, .invalidComboContainer').length > 0) {
      var el = $('#invalidComboContainer, .invalidComboContainer').parents('form').find('.selectHasError')[0];
      this.focusFirstAttrError(el);
    }
    try {
      this.props.passedAppFunctions.rerunTargetFixes();
    } catch (e) {}
  }

  checkVideoChat() {
    var observer = new MutationObserver(function (mutations, me) {
      var tags = document.getElementById('dillards-tags');
      if (tags) {
        if (window.insideFrontInterface !== undefined && insideFrontInterface.getAvailableAssistants !== undefined) {
          var findAssistants = window.insideFrontInterface.getAvailableAssistants() || [];
          if (findAssistants.length > 0) {
            for (let i = 0; i < findAssistants.length; i++) {
              if (findAssistants[i].name === 'Video Chat Enabled') {
                //Show beauty chat button
                var beautyChatButton = document.getElementsByClassName('beauty-chat');
                Array.prototype.forEach.call(beautyChatButton, function (beautyChatButton) {
                  beautyChatButton.style.display = 'block';
                });
                me.disconnect();
              }
            }
          }
        }
        return;
      }
    });
    observer.observe(document, {
      childList: true,
      subtree: true,
    });
  }

  componentWillUnmount(result) {
    this.checkVideoChat();
    this.automationUnexpose();
    // try {
    // 	window.mql.removeListener(function (m) {
    // 		window.rerunStyliticsWidget(window.rerunStyliticsColorway);
    // 	});
    // } catch (e) {
    // 	console.log(e);
    // }
    // try {
    // 	window.mql.removeListener(function (m) {
    // 		window.rerunStyliticsWidget(window.rerunStyliticsColorway);
    // 	});
    // } catch (e) {
    // 	console.log(e);
    // }
    //stylitics can be on a modal with styling applied when unload happens
    $('body').css('overflow', '');

    window.removeEventListener('updateMocks', this.setAltClicked);
  }

  setAltClicked = () => {
    this.setState({
      altClicked: true,
    });
  };

  async componentDidMount() {
    this.getProductImagesArray(this.props.contentData);
    this.checkVideoChat();

    window.addEventListener('updateMocks', this.setAltClicked);

    if (
      this.props.passedAppFunctions.siteFormat == 'desktop' &&
      this.props.contentData.productLayout == 'ProductDisplay' &&
      this.props.passedAppFunctions.quickviewIsOpen == false
    ) {
      this.checkMainImageLoad();
    }
    this.setDefaultImageByURLParam(
      this.props.passedAppFunctions.getURLParamValue('df'),
      this.props.passedAppFunctions.getURLParamValue('di'),
      this.props
    );

    // if the selected main image isn't in the alt images at all, case to handle bad data
    if (
      this.state.swatchGroups &&
      this.state.swatchGroups.length > 0 &&
      this.state.swatchGroups[0].swatches.length > 0 &&
      this.state.swatchGroups.filter((swatchGroup) =>
        swatchGroup.swatches.filter((el) => el.fullImage == this.state.selectedMainImg)
      ).length == 0
    ) {
      this.setState({ selectedMainImg: this.state.swatchGroups[0].swatches[0].fullImage });
    }

    this.automationExpose();
    //if we stored off an attempt and we are back, try again
    if (window.Modernizr && Modernizr.sessionstorage && this.props.passedAppFunctions.getURLParamValue('krypto')) {
      var wlAttempt = sessionStorage.getItem('wlAttempt');
      var regAttempt = sessionStorage.getItem('regAttempt');
      var mfbAttempt = sessionStorage.getItem('mfbAttempt');
      var attemptId = sessionStorage.getItem('attemptId');
      if (wlAttempt && attemptId == this.props.contentData.productId) {
        sessionStorage.removeItem('attemptId');
        if (wlAttempt == '-') {
          this.ajaxAddToWishlist();
        } else {
          const splitAttempt = wlAttempt.split('|');
          let wlAttemptObj = {};
          splitAttempt.forEach((splitItem) => {
            let attrName = splitItem.split(':')[0];
            let selectedValue = splitItem.split(':')[1];
            let updatedStateObj = { [attrName]: { attrName: attrName, selectedValue: selectedValue } };
            Object.assign(wlAttemptObj, updatedStateObj);
          });
          if (wlAttempt.includes('Color')) {
            this.setDefaultImageByURLParam(wlAttempt, '', this.props);
          }
          this.state.currentAttributeState = wlAttemptObj;
          this.ajaxAddToWishlist();
        }
      }
      if (regAttempt && attemptId == this.props.contentData.productId) {
        sessionStorage.removeItem('regAttempt');
        sessionStorage.removeItem('attemptId');
        if (regAttempt == '-') {
          this.ajaxAddToRegistry();
        } else {
          const splitAttempt = regAttempt.split('|');
          let regAttemptObj = {};
          splitAttempt.forEach((splitItem) => {
            let attrName = splitItem.split(':')[0];
            let selectedValue = splitItem.split(':')[1];
            let updatedStateObj = { [attrName]: { attrName: attrName, selectedValue: selectedValue } };
            Object.assign(regAttemptObj, updatedStateObj);
          });
          this.state.currentAttributeState = regAttemptObj;
          this.ajaxAddToRegistry();
        }
      }
      if (mfbAttempt && attemptId == this.props.contentData.productId) {
        this.setState({ isAddToBrandFavs: true });
        sessionStorage.removeItem('mfbAttempt');
        sessionStorage.removeItem('attemptId');
        await this.ajaxAddToBrandFavorites();
      }
    }
    if (
      this.props.passedAppFunctions &&
      this.props.passedAppFunctions.fromQv &&
      this.props.passedAppFunctions.fromQv == true
    ) {
      try {
        this.props.passedAppFunctions.rerunTargetFixes();
      } catch (e) {}
    }

    this.personalizationTracking(1);
    this.resetFreqOnMount();

    if (this.props.passedAppFunctions.quickviewIsOpen == false) {
      window.rerunStyliticsColorway = this.formatColorWay(this.props.contentData.partNumber, this.getStyliticsColor());
      window.rerunStyliticsWidget = this.populateDdsStyliticsWidgetInstance;

      try {
        window.mql = window.matchMedia('(orientation: portrait)');

        mql.addListener(function (m) {
          window.rerunStyliticsWidget(window.rerunStyliticsColorway);
        });
      } catch (e) {
        console.log(e);
      }

      this.populateDdsStyliticsWidgetInstance(window.rerunStyliticsColorway);
    }
  }

  setDefaultImageByURLParam(dfParam, diParam, nextProps) {
    var newPotentialImage = '';
    var pageType =
      nextProps.contentData && nextProps.contentData.productLayout ? nextProps.contentData.productLayout : '';

    if (pageType != 'OutfitDisplay' && pageType != 'BundleDisplay' && pageType != 'OutfitComponent' && pageType != '') {
      if (dfParam != '') {
        newPotentialImage = dfParam.split('-').join(' ');
        if (newPotentialImage && newPotentialImage !== '') {
          var altImages =
            nextProps.contentData && nextProps.contentData.altImages ? nextProps.contentData.altImages : [];
          for (var thisAlt of altImages) {
            if (
              thisAlt.imageName &&
              thisAlt.altText &&
              (thisAlt.altText.toLowerCase().indexOf(newPotentialImage) > -1 ||
                thisAlt.altText.split(' - ')[0] == newPotentialImage)
            ) {
              this.state.selectedMainImg = thisAlt.imageName;
              break;
            }
          }
        }
      } else if (diParam != '') {
        newPotentialImage = nextProps.passedAppFunctions.linkToState.di
          ? nextProps.passedAppFunctions.linkToState.di
          : diParam;
        if (newPotentialImage != '') {
          this.state.selectedMainImg = newPotentialImage;
        }
      } else if (nextProps.passedAppFunctions.linkToState && nextProps.passedAppFunctions.linkToState.di) {
        this.state.selectedMainImg = nextProps.passedAppFunctions.linkToState.di;
      }
    }
  }

  checkMainImageLoad() {
    if (
      this.props.passedAppFunctions.siteFormat == 'desktop' &&
      this.props.contentData.productLayout == 'ProductDisplay' &&
      this.props.passedAppFunctions.quickviewIsOpen == false
    ) {
      var mainProductImage = document.getElementById('main-product-image');
      if (mainProductImage?.complete == false) {
        mainProductImage.addEventListener('load', this.mainImageLoaded);
        mainProductImage.addEventListener('error', this.mainImageLoaded);
      } else {
        if (mainProductImage?.complete == true) {
          document.getElementById('main-img-wrapper').style.height = 'auto';
        }
      }
    }
  }

  altImageClicked = (e) => {
    let dataKey = parseInt(e.target.getAttribute('data-key'));
    this.updateAttributeFromAltClick(e);
    this.setState({
      altClicked: true,
      altIndex: dataKey,
    });
  };

  buildSwatchGroupsFromSkus(contentData, skus) {
    if (skus) {
      let skusByColor = [];
      // if its a sales page, reduce skus first
      if (contentData.salePage == 'true') {
        const saleItemSkus = skus.reduce((acc, item) => {
          if (item.onSpecial > 0) {
            acc.push(item);
          }
          return acc;
        }, []);
        skusByColor = saleItemSkus?.reduce((skusByAttrVals, sku) => {
          //if the sku has 1 attribute then use it to group, otherwise find the color and group by that
          const attribute =
            sku?.definingAttributes.length === 1
              ? [sku?.definingAttributes[0]]
              : sku?.definingAttributes?.filter((attr) => attr?.name === 'Color');
          if (attribute.length > 0) {
            const attributeValue = attribute[0].value.value;
            if (skusByAttrVals[attributeValue]) {
              skusByAttrVals[attributeValue].push(sku);
            } else {
              skusByAttrVals[attributeValue] = [sku];
            }
          }
          return skusByAttrVals;
        }, {});
      } else {
        skusByColor = skus?.reduce((skusByAttrVals, sku) => {
          //if the sku has 1 attribute then use it to group, otherwise find the color and group by that
          const attribute =
            sku?.definingAttributes.length === 1
              ? [sku?.definingAttributes[0]]
              : sku?.definingAttributes?.filter((attr) => attr?.name === 'Color');
          if (attribute.length > 0) {
            const attributeValue = attribute[0].value.value;
            if (skusByAttrVals[attributeValue]) {
              skusByAttrVals[attributeValue].push(sku);
            } else {
              skusByAttrVals[attributeValue] = [sku];
            }
          }
          return skusByAttrVals;
        }, {});
      }

      //Go through the colors, group them by prices, and transform the skus lists into a swatch list and pricing info
      const pricingObj = Object.keys(skusByColor)?.reduce((swatchPricingObj, colorName) => {
        const skusInOfferOrder = skusByColor[colorName].sort((a, b) => a.offer.price - b.offer.price);
        const offerPriceMin = skusInOfferOrder[0].offer.price.toFixed(2);
        const offerPriceMax = skusInOfferOrder[skusInOfferOrder.length - 1].offer.price.toFixed(2);
        const offerPriceRange = offerPriceMin == offerPriceMax ? offerPriceMax : `${offerPriceMin} - ${offerPriceMax}`;

        const skusInListOrder = skusByColor[colorName].sort((a, b) => a.listPrice - b.listPrice);
        const listPriceMin = skusInListOrder[0].listPrice.toFixed(2);
        const listPriceMax = skusInListOrder[skusInListOrder.length - 1].listPrice.toFixed(2);
        const listPriceRange = listPriceMin === listPriceMax ? listPriceMin : `${listPriceMin} - ${listPriceMax}`;

        const { fullImage, onSpecial, onSpecialMessage, dept, mic, style, thumbnail, definingAttributes } =
          skusInOfferOrder[0];

        const attribute =
          definingAttributes.length === 1
            ? [definingAttributes[0]]
            : skusInOfferOrder[0]?.definingAttributes?.filter((attr) => attr?.name === 'Color');
        const { value, sequence } = attribute[0].value;

        if (swatchPricingObj[offerPriceRange]) {
          swatchPricingObj[offerPriceRange]?.swatches.push({
            colorForSwatch: value,
            fullImage,
            swatchImg: thumbnail,
            sequence,
          });
        } else {
          const isOnSpecial = onSpecial !== 0;
          swatchPricingObj[offerPriceRange] = {
            pricing: {
              dept,
              mic,
              style,
              catentryId: contentData.productId,
              swatchPricing: 'true',
              offerPriceMin,
              offerPriceMax,
              offerPriceRange,
              onSpecial: isOnSpecial ? onSpecial : undefined,
              onSpecialMessage: isOnSpecial ? onSpecialMessage : undefined,
              originalPriceMessage: contentData?.pricing?.originalPriceMessage,
              onSpecialMessageQV: contentData?.pricing?.onSpecialMessageQV,
              listPriceMin: isOnSpecial ? `${listPriceMin}` : undefined,
              listPriceMax: isOnSpecial ? `${listPriceMax}` : undefined,
              listPriceRange: isOnSpecial ? `${listPriceRange}` : undefined,
              markDown: contentData?.pricing?.markDown,
            },
            swatches: [
              {
                colorForSwatch: value,
                fullImage,
                swatchImg: thumbnail,
                sequence,
              },
            ],
          };
        }

        return swatchPricingObj;
      }, {});

      const swatchGroupsFromSkus = Object.values(pricingObj);
      swatchGroupsFromSkus?.forEach((swatchGroup) => {
        swatchGroup.swatches.sort((a, b) =>
          a.sequence === b.sequence ? a.colorForSwatch.localeCompare(b.colorForSwatch) : a.sequence - b.sequence
        );
      });

      return { pricingObj, swatchGroupsFromSkus };
    } else {
      return { pricingObj: {}, swatchGroupsFromSkus: {} };
    }
  }

  mainImageLoaded() {
    var mainImageWarapper = document.getElementById('main-img-wrapper');
    var mainProductImage = document.getElementById('main-product-image');
    mainImageWarapper.style.height = 'auto';
    mainProductImage?.removeEventListener('load', this.mainImageLoaded);
    mainProductImage?.removeEventListener('error', this.mainImageLoaded);
  }

  initializeStateObjects(contentData, fromConstructor) {
    if (contentData.productLayout) {
      if (['OutfitDisplay', 'BundleDisplay', 'BundleDisplayChanel'].indexOf(contentData.productLayout) == -1) {
        //NON-BUNDLES
        //SET UP INITIAL ATTRIBUTE STATE

        let swatchState = {};
        swatchState.swatches = [];
        contentData.skus.map((sku) => {
          let fullImage = sku.fullImage;
          let swatchImg = sku.thumbnail;
          sku.definingAttributes.map((attr) => {
            if (attr.name === 'Color') {
              let colorForSwatch = attr.value.value;
              let swatchStr = { colorForSwatch, fullImage, swatchImg };
              let hasColor = swatchState.swatches.some((color) => color.colorForSwatch === colorForSwatch);
              if (!hasColor) {
                swatchState.swatches.push(swatchStr);
              }
            }
          });
        });
        let swatchGroups2 = new Array(swatchState);

        let skus = contentData.skus;
        const attributeMain = {};
        const attrsVals = {};

        // AttributesMain - This Object is used to build inputs - need to ask about default Selected
        //Now I have the defaultSelected as the attribute name on dropdowns - nothing on buttons
        skus?.map((sku) => {
          if ((contentData.salePage == 'true' && sku.onSpecial > 0) || contentData.salePage !== 'true') {
            sku.definingAttributes.map((attribute, index) => {
              const attrID = index;
              const name = attribute.name;
              const valueArr = attribute.value;
              const valueArrString = JSON.stringify(attribute.value);
              const displayStyle = attribute.displayStyle;
              const defaultSelected = attribute.defaultSelected;
              const sequence = attribute.sequence;

              if (attributeMain[name]) {
                const alreadyHasValue = attributeMain[name].values.some((aValue) => {
                  return aValue.value === valueArr.value;
                });
                if (!alreadyHasValue) {
                  attributeMain[name].values.push(valueArr);
                }
              } else {
                attributeMain[name] = { sequence, name, displayStyle, defaultSelected, attrID };
                attributeMain[name].values = [valueArr];
              }
            });
          }
        });
        //Sort Array by Attribute Sequence Number
        const attrMainSorted = Object.fromEntries(
          Object.entries(attributeMain).sort((a, b) => a[1].sequence - b[1].sequence)
        );
        // All Possibilities of Attributes with CatID, images, prices, etc...
        skus?.map((sku, index) => {
          const catentryId = sku.catentryId;
          const fullImageName = sku.fullImage;
          const fullThumbNail = sku.thumbnail;
          const listPrice = sku.offer.price;
          let salePrice = '';
          const isOnSale = sku.offer.isOnSale;
          let hasPriceRange = false;
          if (isOnSale) {
            hasPriceRange = true;
            salePrice = sku.offer.price;
          }
          sku.definingAttributes.map((attr) => {
            const name = attr.name;
            const value = attr.value.value;
            if (attrsVals[catentryId]) {
              attrsVals[catentryId].values = [...(attrsVals[catentryId].values || []), { name, value }];
            } else {
              attrsVals[catentryId] = { catentryId, fullImageName, fullThumbNail, listPrice, hasPriceRange, salePrice };
              attrsVals[catentryId].values = [{ name, value }];
            }
          });
        });

        //FormValidation Object State - It contains a skeleton of the types of attributes are needed for the page
        //it initially sets the value to undefined - onChange events takes selected value and inserts it to the matching AttrName
        let currentAttributeState = {};
        Object.keys(attrMainSorted).map((vals) => {
          let attrName = vals;
          let selectedValue = undefined;
          if (currentAttributeState[attrName]) {
            currentAttributeState[attrName] = [...(currentAttributeState[attrName] || []), { attrName, selectedValue }];
          } else {
            currentAttributeState[attrName] = { attrName, selectedValue };
          }
        });

        //This Object sorts All SKUS as well as their matching values
        //it's used to map through with selected values and find SKU to send to back end
        let skuNosVals = {};
        skus?.map((sku, index) => {
          const catentryId = sku.catentryId;
          sku.definingAttributes.map((attr) => {
            const name = attr.name;
            const catID = attr.catentryId;
            const value = attr.value.value;
            if (skuNosVals[catentryId]) {
              skuNosVals[catentryId].values = [...(skuNosVals[catentryId].values || []), value];
            } else {
              skuNosVals[catentryId] = { catentryId };
              skuNosVals[catentryId].values = [value];
            }
          });
        });

        //ARRAY with Attribute Types and all Images for AltClicks, and it's not attached to the Attribute Type/Name AT ALL
        let allImages = [];
        let imgArr = [];
        Object.values(attrsVals).map((val) => {
          let allValues = val.values;
          let imgName = val.fullImageName;
          let imgThumbnail = val.fullThumbNail;
          allValues.map((val) => {
            let attrType = val.name;
            let attrValue = val.value;
            imgArr = { attrType, attrValue, imgName, imgThumbnail };
            allImages.push(imgArr);
          });
        });

        //Pricing
        const { pricingObj, swatchGroupsFromSkus } = this.buildSwatchGroupsFromSkus(contentData, contentData.skus);
        //Get Each Skus Option Prices
        const itemPricingObj = {};
        Object.values(skus).map((sku) => {
          let catentryId = sku.catentryId;
          let isOnSale = sku.offer.isOnSale;
          let optionPrice = sku.offer.price;
          sku.definingAttributes.map((attr) => {
            const name = attr.name;
            const value = attr.value.value;
            let nameValPair = { name, value };
            if (itemPricingObj[catentryId]) {
              itemPricingObj[catentryId].values = [...(attrsVals[catentryId].values || []), nameValPair];
            } else {
              itemPricingObj[catentryId] = { catentryId, optionPrice, isOnSale };
              itemPricingObj[catentryId].values = [nameValPair];
            }
          });
        });

        const priceRangeObj = {};
        // skus.forEach((sku => {
        // 	sku.definingAttributes.forEach((defAttr => {
        // 		let price = sku.offer.price;
        // 		if(priceRangeObj[defAttr.name]) {
        // 			if(priceRangeObj[defAttr.name][defAttr.value.value]) {
        // 				const currentMin = priceRangeObj[defAttr.name][defAttr.value.value].minPrice;
        // 				const currentMax = priceRangeObj[defAttr.name][defAttr.value.value].maxPrice;
        // 				if(price > currentMax) {
        // 					priceRangeObj[defAttr.name][defAttr.value.value].maxPrice = price;
        // 				}
        // 				if(price < currentMin) {
        // 					priceRangeObj[defAttr.name][defAttr.value.value].minPrice = price;
        // 				}
        // 			} else {
        // 				priceRangeObj[defAttr.name][defAttr.value.value] = { minPrice: price, maxPrice: price};
        // 			}
        // 		}
        // 		else {
        // 			priceRangeObj[defAttr.name] = {};
        // 			priceRangeObj[defAttr.name][defAttr.value.value] = { minPrice: price, maxPrice: price };
        // 		}

        // 	}))
        // }))

        //What type of Product(oneAttribute, Item, Initial, Standard)
        let productPageType = 'Standard';
        if (Object.keys(currentAttributeState).includes('Item')) {
          productPageType = 'Item';
        }
        if (Object.keys(currentAttributeState).includes('Initial') && Object.keys(currentAttributeState).length !== 1) {
          productPageType = 'Initial';
        }
        if (Object.keys(currentAttributeState).length === 1 && Object.keys(currentAttributeState).includes('Initial')) {
          productPageType = 'One Attribute Initial';
        }
        if (
          Object.keys(currentAttributeState).length === 1 &&
          !Object.keys(currentAttributeState).includes('Initial') &&
          !Object.keys(currentAttributeState).includes('Item')
        ) {
          productPageType = 'One Attribute';
        }

        //Old way but not ready to comment it out just yet/////
        var attrState = {};
        attrState.attributes = [];
        skus?.map((sku, index) => {
          const catentryId = sku.catentryId;
          sku.definingAttributes.map((attr, index) => {
            const thisAttr = attr;
            var newAttribute = {};
            newAttribute = { ...thisAttr };
            newAttribute.availableValues = thisAttr;

            if (!attrState.attributes.includes(thisAttr)) {
              attrState.attributes.push(newAttribute);
            }
          });
        });
        var attributeState = {};
        attributeState.attributes = [];
        if (contentData.attributes) {
          for (var iAttr = 0; iAttr < contentData.attributes.length; iAttr++) {
            var thisAttribute = contentData.attributes[iAttr];
            var newAttribute = {};
            newAttribute = { ...thisAttribute };
            newAttribute.availableValues = thisAttribute.values;
            newAttribute.notAvailableValues = [];
            if (newAttribute.values.length == 1) {
              newAttribute.selectedValue = newAttribute.values[0].value;
              newAttribute.selectedValueInformation = newAttribute.values[0];
            } else {
              newAttribute.selectedValue = '';
              newAttribute.selectedValueInformation = {};
            }
            attributeState.attributes.push(newAttribute);
          }
        }

        /////////////////////////////////////////////////////////////////////////////////////

        this.state.swatchGroups = swatchGroupsFromSkus;
        this.state.attributeState = attributeState;
        this.state.skuNosVals = skuNosVals;
        this.state.allImages = allImages;
        this.state.attributesMain = attrMainSorted;
        this.state.availableValues = attrsVals;
        this.state.pricingObj = pricingObj;
        this.state.itemPricingObj = itemPricingObj;
        // this.state.priceRangeObj = priceRangeObj;
        this.state.productPageType = productPageType;
        this.state.currentAttributeState = currentAttributeState;
        this.state.quantity = 1;

        if (!this.state.selectedMainImg || this.state.selectedMainImg == '') {
          this.state.selectedMainImg = contentData.fullImage && contentData.fullImage.imageNameNoPath;
        }
        this.state.formValid = this.validateForm(this.state.currentAttributeState);
        //Preselect color for OSS
        if (this?.props?.contentData?.extraQVProps?.OSS) {
          //search the OSS object for the product currently displayed in the QV
          const activeAccessory = this?.props?.contentData?.extraQVProps?.OSS?.find(
            (ossAccessory) => ossAccessory.dil_oss_acc_catentry_id == this.props.contentData.productId
          );
          if (activeAccessory?.dil_oss_vendor_color != '') {
            //evaluate what color we wanna swap to
            const colorToFind = activeAccessory.dil_oss_vendor_color;

            const skusWithTheColor = this.props.contentData.skus.filter((sku) => {
              return sku.definingAttributes.some((attribute) => {
                if (attribute.value.value === colorToFind) {
                  this.updateAttributeState(attribute.name, attribute.value.value, 'Collections', colorToFind);
                }
                return attribute.value.value === colorToFind;
              });
            });

            if (skusWithTheColor?.length === 0) {
              //the oss color was not available, so lets set the message that will show
              this.state.colorNotAvailable = colorToFind;
            }
          }
        }

        //preselect color for collection
        if (
          this.props.contentData.extraQVProps &&
          this.props.contentData.extraQVProps.collection &&
          this.props.contentData.extraQVProps.collection.details
        ) {
          var activeCollectionItem = this.props.contentData.extraQVProps.thisCollectionMember;
          if (activeCollectionItem && activeCollectionItem.color != '') {
            //evaluate what color we wanna swap to
            var colorToFind = activeCollectionItem.color;
            const skusWithTheColor = this.props.contentData.skus.filter((sku) => {
              return sku.definingAttributes.some((attribute) => {
                if (attribute.value.value === colorToFind) {
                  this.updateAttributeState(attribute.name, attribute.value.value);
                }
                return attribute.value.value === colorToFind;
              });
            });
            if (skusWithTheColor?.length === 0) {
              //the oss color was not available, so lets set the message that will show
              this.state.colorNotAvailable = colorToFind;
            }
          }
        }

        //Need to make sure this is being covered...have ??s
        if (
          typeof window != 'undefined' &&
          window.injectedAttributeStateFunction &&
          this.state.attributeState &&
          contentData[`onSaleInfo_${contentData.productId}`] &&
          contentData[`onSaleInfo_${contentData.productId}`].onSaleItemMap &&
          contentData.pricing
        ) {
          this.state.attributeState = window.injectedAttributeStateFunction(
            JSON.parse(JSON.stringify(this.state.attributeState)),
            contentData[`onSaleInfo_${contentData.productId}`].onSaleItemMap,
            contentData.pricing
          );
        }
      } else {
        //BUNDLES
      }
      //if (!fromConstructor) this.state.selectedMainImg = this.props.passedAppFunctions.getURLParamValue('di');
    }
  }

  changeMainImage(attrName, attrVal) {
    let attrImg, attrThumbnail;
    if (attrName === 'Color' || attrName === 'Initial') {
      Object.values(this.state.allImages).map((vals) => {
        let attrValue = vals.attrValue;
        if (attrValue == attrVal) {
          attrImg = vals.imgName;
          attrThumbnail = vals.imgThumbnail;
        }
      });
      this.state.selectedMainImg = attrImg;
    }
  }

  getCurSelectedAttr(attrName) {
    let curSelectedAttr;
    curSelectedAttr = attrName.split('ID')[0];
    if (curSelectedAttr.length === 0) {
      curSelectedAttr = attrName;
    }
    this.setState({
      curSelectedAttr: curSelectedAttr,
    });
  }

  //BIG STATE OBJECT WITH ALL ATTRIBUTE NAMES WAITING FOR NEW SELECTIONS
  updateAttributeState(attrName, attrVal, fromWhere, fromValue, thisSelectValue) {
    this.getCurSelectedAttr(attrName);
    if (fromWhere === 'Collections') {
      this.changeMainImage(attrName, fromValue);
    }

    if (fromWhere === 'Item') {
      this.state.currentAttributeState[attrName].selectedValue = attrVal;
      this.state.currentAttributeState['Item'].selectedValue = fromValue;
      if (this.state.currentAttributeState['Color'] !== undefined) {
        this.state.currentAttributeState['Color'].selectedValue = thisSelectValue;
      }
    } else {
      const trimmedName = attrName.split('ID')[0];
      if (this.state.currentAttributeState[trimmedName ?? attrName] !== undefined) {
        this.state.currentAttributeState[trimmedName ?? attrName].selectedValue = attrVal;
      }
    }
    //Now, let's use the attrName and attrVal to update the Main Image
    attrName = attrName.split('ID')[0];
    if (attrName !== 'Size') {
      this.changeMainImage(attrName, attrVal);
    }

    if (this.props.passedAppFunctions && !this.props.passedAppFunctions.quickviewIsOpen) {
      if (attrName === 'Color') {
        this.populateDdsStyliticsWidgetInstance(this.formatColorWay(this.props.contentData.partNumber, attrVal));
      }
    }

    //Let's add and set state with the value selected
    this.setState({
      currentAttributeState: { ...this.state.currentAttributeState },
    });
  }

  updateAttrState(changedAttributeId, changedAttributeValue, forcedImg, fromConstructor) {
    // console.log("changedAttributeId", changedAttributeId)
  }
  updateSwatchGroups(passedAttributes, contentData) {
    if (contentData.productLayout == 'QuickViewDisplay') {
      this.state.possibleIncorrectProductId = false;
    } else {
      if (this.state.possibleIncorrectProductId) {
        if (this.state.productId != contentData.productId) {
          passedAttributes = this.state.correctPassedAttributes;
          contentData = this.state.correctContentData;
          this.state.possibleIncorrectProductId = false;
        }
      } else {
        this.state.productId = contentData.productId;
        this.state.correctPassedAttributes = passedAttributes;
        this.state.correctContentData = contentData;
        this.state.possibleIncorrectProductId = true;
      }
    }
    var newSwatchGroups = JSON.parse(JSON.stringify(this.state.swatchGroups || []));

    var colorAttr;
    for (var iAttr = 0; iAttr < passedAttributes.attributes.length; iAttr++) {
      var thisAttr = passedAttributes.attributes[iAttr];
      if (thisAttr.attrName == 'Color') colorAttr = thisAttr;
    }
    if (colorAttr && newSwatchGroups.length > 0) {
      //set available flags on swatches
      for (var iAvailable = 0; iAvailable < colorAttr.availableValues.length; iAvailable++) {
        var thisAttrValue = colorAttr.availableValues[iAvailable];
        var thisAttrValueName = thisAttrValue.name;
        for (var iSwatchGroup = 0; iSwatchGroup < newSwatchGroups.length; iSwatchGroup++) {
          var thisSwatchGroup = newSwatchGroups[iSwatchGroup];
          for (var iSwatch = 0; iSwatch < thisSwatchGroup.swatches.length; iSwatch++) {
            var thisSwatch = thisSwatchGroup.swatches[iSwatch];
            if (thisSwatch.colorForSwatch && thisAttrValueName && thisSwatch.colorForSwatch == thisAttrValueName) {
              //this swatch is available
              thisSwatch.available = true;
              thisSwatch.selectedValue = thisAttrValue.value;
              thisSwatch.attrId = colorAttr.attrId;
            }
          }
        }
      }
    }
    return newSwatchGroups;
  }

  validateForm(newAttributeState) {
    var formValid = true;
    let formIssues = true;
    if (this.state.addToBagClicked === true && Object.keys(this.state.currentAttributeState).length > 0) {
      const availableSkus = this.state.availableValues;
      const stateValues = Object.values(this.state.currentAttributeState);
      // const valid = [];
      let isValidCombination = false;
      Object.values(availableSkus).map((sku) => {
        let valuesMatch = true;
        sku.values.map((attr) => {
          let thisSkuName = attr.name;
          let thisSkuValue = attr.value !== undefined ? attr.value.toLowerCase() : '';
          let stateEntryMatch = stateValues.find((match) => match.attrName === thisSkuName);
          let userSelectedValue =
            stateEntryMatch.selectedValue !== undefined ? stateEntryMatch.selectedValue.toLowerCase() : '';
          if (thisSkuValue !== userSelectedValue) {
            valuesMatch = false;
          }
        });
        if (valuesMatch) {
          isValidCombination = true;
        }
      });
      formValid = isValidCombination;
      this.setState({
        formValid: isValidCombination,
      });
    } else {
      Object.values(this.state.currentAttributeState).map((attrVals) => {
        let attrName = attrVals.attrName;
        let selValue = this.state.currentAttributeState[attrName].selectedValue;
        if (!selValue) {
          let formIssues = true;
          Object.values(this.state.currentAttributeState).map((attrVals) => {
            let attrName = attrVals.attrName;
            let selValue = this.state.currentAttributeState[attrName].selectedValue;
            if (!selValue) {
              formValid = false;
            }
          });
          if (this.state.quantity == '' || !formIssues) {
            formValid = false;
          }
        }
      });
    }
    if (this.state.quantity == '' || !formIssues) {
      formValid = false;
    }
    // if (formValid === false) {
    // 	this.formNotValid();
    // }
    return formValid;
  }

  currencySymbol(second) {
    if (typeof window == 'undefined' || window.DILLARDS.country == 'US') {
      return '$';
    } else {
      if (second) return '';
      return window.DILLARDS.currency + ' ';
    }
  }
  roundUp(price, roundMethod) {
    var multiple = Math.pow(10, roundMethod);
    return Math.round(price * multiple) / multiple;
  }
  priceConvert(priceIn) {
    //ONLY FOR USE IN OPTIONS BECAUSE IT REQUIRES A STRING---USE <Price /> WHERE POSSIBLE!
    priceIn = (priceIn + '').split('$').join('') * 1;
    //if (typeof window == 'undefined' || window.DILLARDS.country == 'US') {
    return priceIn.toFixed(2);
    /*} else {
			var countryObj = window.dillardsIntlObj.countryCode()[window.DILLARDS.country],
				currencyObj = window.dillardsIntlObj.currencyCode()[window.DILLARDS.currency],
				flc = countryObj.getFLC,
				currencyCode = currencyObj.getCurrencyCode,
				exchangeRate = currencyObj.getExchangeRate,
				roundMethod = currencyObj.getRoundMethod,
				toConvert = priceIn * exchangeRate * flc,
				convertedValue = roundMethod < 0 ? parseFloat(this.roundUp(toConvert, roundMethod)) : parseFloat(toConvert).toFixed(roundMethod);
			return convertedValue;
		}*/
  }
  forceQuantity() {
    this.setState({ quantity: 1 });
  }
  updateQuantity(event) {
    var maximumQuantity = event.target.getAttribute('data-maximum') * 1;
    var minimumQuantity = event.target.getAttribute('data-minimum') * 1;
    var targetValue = event.target.value || event.target.getAttribute('data-value');
    if (targetValue == null || targetValue == undefined) targetValue = '';
    let blankQuantity = targetValue == '',
      lessThanMax = targetValue <= maximumQuantity,
      greaterThanMin = targetValue >= minimumQuantity,
      isANum = !isNaN(targetValue),
      isANum_space = isANum && targetValue.toString().indexOf(' ') > -1,
      decimalNum = targetValue.toString().indexOf('.') > -1,
      noPeriodsOrSpaces = !(isANum_space || decimalNum);
    if (blankQuantity || (isANum && noPeriodsOrSpaces && lessThanMax && greaterThanMin)) {
      this.state.quantity = targetValue;
      this.setState({ quantity: targetValue, quantityErrored: false });
    }
  }
  updateAttribute(event) {
    // let forcedImg = event.currentTarget.getAttribute('data-imagename');
    // var changedAttributeId = event.target.getAttribute('data-attrid');
    // var changedAttributeValue = event.target.value || event.target.getAttribute('data-attrval');
    // this.updateAttributeState2(changedAttributeId, changedAttributeValue, forcedImg);
    // return false;
  }

  changeAttributeState(event) {
    // this.updateAttribute(event)
    let changedAttributeName =
      event.currentTarget.getAttribute('data-attrtype') || event.currentTarget.name || event.currentTarget.id;
    let changedAttributeValue = event.currentTarget.value || event.currentTarget.getAttribute('data-attrval');
    let isColorSwatch = changedAttributeName.includes('Color') || changedAttributeName.includes('Swatch');
    if (changedAttributeName == 'Swatch') {
      changedAttributeName = 'Color';
    }
    this.setState({
      selectedAttributeName: changedAttributeName,
      selectedAttributeValue: changedAttributeValue,
    });

    //Until we change how we are getting swatch data, if it's a swatch attribute that's clicked, let's treat it like a color
    if (isColorSwatch) {
      this.updateAttributeState('Color', changedAttributeValue);
    } else {
      this.updateAttributeState(changedAttributeName, changedAttributeValue);
    }

    if (isColorSwatch) {
      this.setState({
        selectedAttributeValue: changedAttributeValue,
        altClicked: false,
      });
      this.changeMainImage(changedAttributeName, changedAttributeValue);
    }
    $(document).trigger('sizeChange');
  }

  //Alt Image - let's get its imagename - split the image name to get fullImage name to match the image name in Skus
  updateAttributeFromAltClick(event) {
    let forcedImg = event.currentTarget.getAttribute('data-imagename');
    const dataType = event.currentTarget.getAttribute('data-attrtype');
    let imgAltClicks = forcedImg.split('_ai')[0]?.split('__')[0];
    this.setState({ selectedMainImg: forcedImg });

    if (dataType === 'Color') {
      this.changeAttributeState(event);
    }
    //Added data-imagename attribute to buttons/images, if we find a match and it's defining attribute is Color
    this.state.allImages.map((val) => {
      if (imgAltClicks == val.imgName) {
        let getAttrType = val.attrType;
        let getAttrValue = val.attrValue;
        if (getAttrType === 'Color' || getAttrType === 'Initial') {
          let selVal = getAttrValue;
          this.state.currentAttributeState[getAttrType].selectedValue = selVal;
        }
      }
    });
    this.state.currentAttributeState = { ...this.state.currentAttributeState };
  }

  updateAttributeFromAltSwipe(index) {
    var forcedImg = this.props.contentData.altImages[index].imageName;
    var forcedFullImg = forcedImg.split('_zi_')[1]?.split('__')[0];
    //Lets look for Color and our newly selected color.
    var colorAttribute;
    if (this.state.attributeState) {
      for (var iAttr = 0; iAttr < this.state.attributeState.attributes.length; iAttr++) {
        var thisAttribute = this.state.attributeState.attributes[iAttr];
        if (thisAttribute.attrName == 'Color') colorAttribute = thisAttribute;
      }
    }

    if (colorAttribute) {
      var colorAttributeValue;
      for (var iAttrVal = 0; iAttrVal < colorAttribute.values.length; iAttrVal++) {
        var thisAttributeValue = colorAttribute.values[iAttrVal];
        var hashOrColorValue = thisAttributeValue.fullImage.split('_zi_')[1];
        if (hashOrColorValue == forcedFullImg) {
          colorAttributeValue = thisAttributeValue;
        }
      }
      this.updateAttributeState2(colorAttribute.attrId, colorAttributeValue.value, forcedImg);
    } else {
      this.setState({ selectedMainImg: forcedImg });
    }
  }

  updateAttributeState2(changedAttributeId, changedAttributeValue, forcedImg, fromConstructor) {
    var newAttributeState = JSON.parse(JSON.stringify(this.state.attributeState));

    var callStylitics = false;

    //limit available values
    var changedAttribute = {};
    var notChangedAttribute = false;

    for (var iAttr = 0; iAttr < newAttributeState.attributes.length; iAttr++) {
      var thisAttribute = newAttributeState.attributes[iAttr];
      if (thisAttribute.attrId == changedAttributeId) {
        thisAttribute.hasError = false;
        changedAttribute = thisAttribute;
      } else {
        notChangedAttribute = thisAttribute;
      }
    }

    //color changed and is not QV
    if (
      changedAttribute.attrName == 'Color' &&
      (changedAttribute.selectedValue == '' ||
        (changedAttribute.selectedValue && changedAttribute.selectedValue != changedAttributeValue))
    ) {
      if (this.props.passedAppFunctions && !this.props.passedAppFunctions.quickviewIsOpen) {
        callStylitics = true;
      }
    }

    changedAttribute.selectedValue = changedAttributeValue;

    if (callStylitics) {
      this.populateDdsStyliticsWidgetInstance(
        this.formatColorWay(this.props.contentData.partNumber, changedAttribute.selectedValue)
      );
    }

    //swatchGroups reevaluation!
    var newSwatchGroups = this.state.swatchGroups;

    if (changedAttribute.attrName == 'Color' && (changedAttributeValue == '' || changedAttributeValue == null)) {
      for (var iSwatchGroup = 0; iSwatchGroup < newSwatchGroups.length; iSwatchGroup++) {
        var thisSwatchGroup = newSwatchGroups[iSwatchGroup];
        for (var iSwatch = 0; iSwatch < thisSwatchGroup.swatches.length; iSwatch++) {
          var thisSwatch = thisSwatchGroup.swatches[iSwatch];
          thisSwatch.selected = false;
        }
      }
    }
    //Dont think we need this
    var newStateToSet = {
      swatchGroups: newSwatchGroups,
      attributeState: newAttributeState,
      formValid: this.validateForm(newAttributeState),
      itemPriceInfo: undefined,
    };
    if (
      (changedAttribute.attrName == 'Color' || changedAttribute.attrName == 'Initial') &&
      changedAttribute.selectedValueInformation &&
      changedAttribute.selectedValueInformation.fullImage
    ) {
      newStateToSet.selectedMainImg = changedAttribute.selectedValueInformation.fullImage;
    }
    if (forcedImg) {
      newStateToSet.selectedMainImg = forcedImg;
    }
    var iState;
    if (!fromConstructor) {
      for (iState = 0; iState < Object.keys(newStateToSet).length; iState++) {
        var thisStateKey = Object.keys(newStateToSet)[iState];
        this.state[thisStateKey] = newStateToSet[thisStateKey];
      }
      this.setState(newStateToSet);
    } else {
      //need to move state properties over
      for (iState = 0; iState < Object.keys(newStateToSet).length; iState++) {
        thisStateKey = Object.keys(newStateToSet)[iState];
        this.state[thisStateKey] = newStateToSet[thisStateKey];
      }
    }
  }

  addErrorVisuals(result) {
    if (result !== undefined) {
      var thisAttributeState = JSON.parse(JSON.stringify(this.state.attributeState));
      const thisAttrState = this.state.attributesMain;
      const notSelected = [];
      Object.values(this.state.currentAttributeState).map((attr) => {
        if (attr.selectedValue === undefined) {
          notSelected.push(attr.attrName);
        }
      });
      if (this.props.passedAppFunctions.quickviewIsOpen === false) {
        const erroredSelects = document.querySelectorAll('.selectHasError');
        if (erroredSelects.length > 0) {
          erroredSelects.forEach((select) => {
            select.classList.remove('selectHasError');
          });
        }
        const resultSelects = result.target.form.querySelectorAll('.attrSelect');
        if (resultSelects.length > 0) {
          resultSelects.forEach((select) => {
            let selectName = select.getAttribute('name');
            if (notSelected.includes(selectName)) {
              select.classList.add('selectHasError');
            } else {
              select.classList.remove('selectHasError');
            }
          });
        }
      } else {
        if (this.props.passedAppFunctions.quickviewIsOpen === true) {
          const qvAttrSelects = document.querySelectorAll('#QuickViewDisplay .attrSelect');
          if (qvAttrSelects.length > 0) {
            qvAttrSelects.forEach((select) => {
              let selectName = select.getAttribute('name');
              if (notSelected.includes(selectName)) {
                select.classList.add('qvSelectHasError');
              } else {
                select.classList.remove('qvSelectHasError');
              }
            });
          }
        }
      }
      this.setState({
        attrState: thisAttrState,
        attributeState: thisAttributeState,
        quantityErrored: this.state.quantity == '',
      });
    }
  }

  generateSharedFormFields(overrideParams) {
    var limitedAvailability = this.props.contentData.limitedAvailability ? 'Y' : 'N';
    var styliticsPageType =
      dataLayer && dataLayer.product && dataLayer.product.pageType
        ? dataLayer.product.pageType
        : this.getPageType(this.props.contentData.productLayout);
    var pageType =
      this.props.passedAppFunctions &&
      this.props.passedAppFunctions.linkToState &&
      this.props.passedAppFunctions.linkToState.stylitics
        ? styliticsPageType
        : this.getPageType(this.props.contentData.productLayout);

    let catentryId = this.getCatentryId();

    if (this.props.contentData.productLayout != 'OutfitComponent') {
      if (this.props.contentData.productLayout.indexOf('Quick') > -1) {
        if (this.props.contentData.extraQVProps && this.props.contentData.extraQVProps.OSS) {
          pageType = pageType + '-OSS';
        }
        if (this.props.contentData.extraQVProps && this.props.contentData.extraQVProps.collection) {
          pageType = pageType + '-SC';
        }
        if (
          this.props.contentData.additionalSizes &&
          this.props.passedAppFunctions.linkToState &&
          this.props.passedAppFunctions.linkToState.addSizeAttribute
        ) {
          pageType = pageType + '-AS';
        }
      }
    } else if (this.props.contentData.productLayout == 'OutfitComponent') {
      if (this.props.contentData.brandNameForTitle == 'Chanel') {
        pageType = 'PP-CBUN';
      } else {
        pageType = 'PP-BUN';
      }
    }

    var returnString = '';
    returnString += 'storeId=301';
    returnString += '&langId=-1';
    returnString += '&catalogId=301';
    returnString += '&orderId=.';
    returnString += '&catEntryId=' + catentryId;
    returnString += '&catEntryId=' + catentryId;
    returnString += '&errorViewName=ProductDisplayView';
    returnString += '&URL=' + (overrideParams && overrideParams.URL ? overrideParams.URL : 'ProductDisplayView');
    returnString += '&rURL=' + (overrideParams && overrideParams.rURL ? overrideParams.rURL : 'ProductDisplayView');
    returnString += '&returnJSON=true';
    returnString += '&productId=' + this.props.contentData.productId;
    returnString += '&limitedAvailability=' + limitedAvailability;
    returnString += `&description=${this.props.contentData.partNumber}|${this.props.contentData.productId}|${
      window.receiveSyndecaMessage
        ? 'syndeca'
        : this.props.passedAppFunctions.getURLParamValue('categoryId') ||
          this.props.passedAppFunctions.linkToState.categoryId ||
          '-10035'
    }|${pageType}|${limitedAvailability}`;

    if (dataLayer && dataLayer.page) {
      returnString += '&primaryCategory=' + dataLayer.page.primaryCategory;
      returnString += '&subCategory1=' + dataLayer.page.subCategory1;
      returnString += '&subCategory2=' + dataLayer.page.subCategory2;
    }

    returnString += '&quantity=' + parseInt(this.state.quantity, 10).toString();
    returnString += '&subscriptionFrequency=' + this.state.subscriptionFrequency;

    return returnString;
  }

  getCatentryId() {
    //What values have been selected
    let curAttrState = this.state.currentAttributeState;
    //get All Skus
    let getDivSKUs = this.props.contentData.skus;
    //filter down to find a match with all defining attributes
    const skuAllAttrVals = Object.values(getDivSKUs).filter((sku) => {
      return sku?.definingAttributes?.every((attribute) => {
        if (
          curAttrState[attribute.name]?.selectedValue.toLowerCase() &&
          curAttrState[attribute.name]?.selectedValue.toLowerCase() != attribute.value.value.toLowerCase()
        ) {
          return false;
        }
        return true;
      });
    });

    let catentryId = '';
    if (skuAllAttrVals.length > 0) {
      catentryId = skuAllAttrVals[0].catentryId;
    }
    return catentryId;
  }

  generateCachedAttributes() {
    var returnString = '';

    Object.values(this.state.currentAttributeState).map((attrVals) => {
      let attrName = attrVals.attrName;

      let selValue = this.state.currentAttributeState[attrName].selectedValue;

      if (returnString.length > 0) returnString += '|';
      returnString += attrName;
      returnString += ':';
      returnString += selValue;
    });

    return returnString;
  }
  async ajaxAddToBrandFavorites() {
    this.state.wlResponse = false;
    var thisPersonalizationId = this.getPersonalizationCategoryId();
    if (thisPersonalizationId) {
      const userInfo = await this.props.passedAppFunctions.getUserInformation();
      if (userInfo.persistent !== undefined) {
        var axiosOptions = {
          method: 'post',
          url: '/webapp/wcs/stores/servlet/Personalization',
        };
        axiosOptions.data = 'fromProductPage=true';
        axiosOptions.data += this.thisBrandInMyFavorites() ? '&action=remove' : '&action=add';
        axiosOptions.data += `&mfName=${thisPersonalizationId}|${this.props.contentData.brandNameForTitle.split('&').join('%26').split('+').join('%2B').split('®').join('%AE')}`;

        axios(axiosOptions).then((ajaxResponse) => {
          let responseJSON;
          try {
            responseJSON = typeof ajaxResponse.data != 'object' ? JSON.parse(ajaxResponse.data) : ajaxResponse.data;
          } catch (e) {}
          if (responseJSON) {
            //update state with the new information
            let responseJSONForState = JSON.parse(JSON.stringify(responseJSON));
            if (responseJSONForState) {
              responseJSONForState.fromMFB = true;
            }

            this.props.passedAppFunctions.wasParms.personalizationCategoryIds
              .split('|')
              .forEach((trackedCatgroupId) => {
                localStorage.removeItem(`myFavoritespersonalization${trackedCatgroupId}`);
              });
            responseJSONForState?.JSON?.dbComments?.forEach((trackedCategoryObject) => {
              Object.keys(trackedCategoryObject).forEach((trackedCategoryId) => {
                const brandsToSave = trackedCategoryObject[trackedCategoryId]
                  .split('|')
                  .map((brandName) => brandName.replace('mfName:', ''));
                localStorage.setItem(`myFavoritespersonalization${trackedCategoryId}`, JSON.stringify(brandsToSave));
              });
            });
            if (this.props.forceBundleRender) {
              this.props.forceBundleRender();
            }
            this.setState({ wlResponse: responseJSONForState });
          } else {
            this.setState({
              wlResponse: { JSON: { status: ['error'] }, fromMFB: true },
            });
          }
        });
      } else {
        var forwardURL = `https://${window.location.host}/webapp/wcs/stores/servlet/LogonForm?`;
        forwardURL += 'URL=' + String(window.location).split('?')[0];
        forwardURL += '&rURL=' + String(window.location).split('?')[0];
        forwardURL += '&storeId=301';
        forwardURL += '&langId=-1';
        forwardURL += '&catalogId=301';

        this.storeAttempt('mfb');

        window.location = forwardURL;
      }
    }
  }
  forceBundleRender() {
    this.setState({});
  }
  addToBagClicked() {
    this.setState({
      addToBagClicked: true,
    });
  }
  formNotValid() {
    this.setState({
      formValid: false,
    });
  }

  checkForErrorsRegistry(result) {
    this.setState({ checkForErrors: true });
    this.ajaxAddToRegistry(result);
  }

  checkForErrorsWishlist(result) {
    this.setState({ checkForErrors: true });
    this.ajaxAddToWishlist(result);
  }

  checkForErrorsMonogram() {
    this.setState({ monogramClicked: true, addToBagClicked: true, checkForErrors: true });
  }

  displayErrorMonogram() {
    this.setState({ itemNotMonogramEligible: true });
  }

  checkForErrorsQV() {
    this.setState({ checkForErrors: true });
  }

  async checkForErrors(result) {
    const { passedAppFunctions, contentData } = this.props;
    const shouldShow = await shouldShowImboxModal({
      passedAppFunctions,
      contentData,
      currentAttributeState: this.state.currentAttributeState,
      quantity: this.state.quantity,
    });
    if (shouldShow) {
      this.props.setShowImboxModal(true);
    } else {
      this.setState({ checkForErrors: true });
      this.ajaxAddToBag(result);
    }
  }

  checkForErrorsItemAttr() {
    this.setState({ checkForErrors: true });
  }

  hideCheckForErrors() {
    this.setState({ checkForErrors: false, itemNotMonogramEligible: false });
  }
  searchABTracking() {
    var returnString = '';
    //if it breaks, it just doesnt add this param.  Let user continue to add to bag.
    try {
      if (typeof window != 'undefined') {
        //for add to bag tracking from a product page from a search result
        if (window.Modernizr && Modernizr.localstorage && localStorage.getItem('lastSearchTerm')) {
          //the user has localStorage available and has searched
          var needFromSearchFlag = false;
          if (this.props.passedAppFunctions.linkToState && this.props.passedAppFunctions.linkToState.fromSearchPage) {
            needFromSearchFlag = true;
          }

          try {
            //this section exists to detect new tab off of search results. Bonus tracking, probably out of scope of card.
            //throwing another try catch inside the try catch cause this is pretty edge case
            //  and dont want to risk all of the other good tracking that could be done
            if (history.length == 1 && document.referrer && document.referrer.indexOf('/search-term/') > -1) {
              var compareString = document.referrer.split('?')[0].split(window.location.host)[1];
              var cleanedTerm = cleanTermForURL(localStorage.getItem('lastSearchTerm'));
              if (
                compareString.indexOf(`/search-term/${cleanedTerm}/`) > -1 ||
                compareString == `/search-term/${cleanedTerm}`
              ) {
                needFromSearchFlag = true;
              }
            }
          } catch (e) {}
          if (needFromSearchFlag) {
            returnString += '|Search:Y';
          }
        }
      }
    } catch (e) {
      console.log(e);
    }
    return returnString;
  }

  //NEED MORE UNDERSTANDING OF THIS
  standardSizeTracking() {
    var returnString = '';
    // try {
    // 	var thisSuper = this.props.contentData.personalization.superCatId;
    // 	if (thisSuper && supersToDoSizeTracking.indexOf(thisSuper) > -1) {
    // 		if (this.state.attributeState && this.state.attributeState.attributes && this.state.attributeState.attributes.length > 0) {
    // 			for (var iAttr = 0; iAttr < this.state.attributeState.attributes.length; iAttr++) {
    // 				var selectedAttrStandardSize = this.state.attributeState.attributes[iAttr].selectedValueInformation.standardSize;
    // 				if (selectedAttrStandardSize) {
    // 					returnString = '|SS:' + selectedAttrStandardSize;
    // 				}
    // 			}
    // 		}
    // 	}
    // } catch (e) {
    // 	// console.log(e);
    // }
    returnString = '|SS:14';
    // try {
    // 	var thisSuper = this.props.contentData.personalization.superCatId;
    // 	if (thisSuper && supersToDoSizeTracking.indexOf(thisSuper) > -1) {
    // 		if (this.state.attributeState && this.state.attributeState.attributes && this.state.attributeState.attributes.length > 0) {
    // 			for (var iAttr = 0; iAttr < this.state.attributeState.attributes.length; iAttr++) {
    // 				var selectedAttrStandardSize = this.state.attributeState.attributes[iAttr].selectedValueInformation.standardSize;
    // 				if (selectedAttrStandardSize) {
    // 					returnString = '|SS:' + selectedAttrStandardSize;
    // 				}
    // 			}
    // 		}
    // 	}
    // } catch (e) {
    // 	// console.log(e);
    // }
    returnString = '|SS:14';
    return returnString;
  }
  ajaxAddToBag(result) {
    //needed for adobe analytics
    var origCartQty =
      this.props.passedAppFunctions.myDillardsInfo &&
      this.props.passedAppFunctions.myDillardsInfo.miniCartInfo &&
      this.props.passedAppFunctions.myDillardsInfo.miniCartInfo.cartItemCount
        ? this.props.passedAppFunctions.myDillardsInfo.miniCartInfo.cartItemCount
        : '';

    this.state.addToBagClicked = true;
    this.state.wlResponse = false;

    this.addErrorVisuals(result);
    if (this.props.passedAppFunctions.siteFormat == 'mobile') {
      if (window.Modernizr && Modernizr.sessionstorage) {
        let pos = $(document).scrollTop();
        sessionStorage.setItem('atbPos', pos);
      } else {
        let pos = $(document).scrollTop();
        Cookies.set('atbPos', pos);
      }
    }
    if (this.validateForm(this.state.currentAttributeState)) {
      try {
        if (window.injectedBeforeAddToBag) window.injectedBeforeAddToBag(this.props.contentData.productId);
      } catch (e) {
        console.log(e);
      }
      this.props.passedAppFunctions.setModalInfo({ modalType: 'Loading' });
      var axiosOptions = {
        method: 'post',
        url:
          '/webapp/wcs/stores/servlet/OrderItemAdd?' +
          (this.props &&
          this.props.contentData &&
          this.props.contentData.productLayout &&
          this.props.contentData.productLayout.indexOf('QuickView') > -1
            ? 'ak=y'
            : 'ak=n'),
      };

      axiosOptions.data = this.generateSharedFormFields();
      axiosOptions.data += '&field2=' + this.generateCachedAttributes();

      axiosOptions.data +=
        '&superAddedFrom=' +
        this.getPersonalizationCategoryId() +
        this.searchABTracking() +
        this.standardSizeTracking() +
        (window['additionalSuperTracking'] ? window['additionalSuperTracking'] : '');

      if (result != undefined && result.Token) {
        axiosOptions.data += '&monogramToken=' + result.Token;
      }

      if (this.props.contentData.dropshipVerbiage) {
        axiosOptions.data += '&dropship=true';
      }

      if (result.imbox && result.imbox === 'true') {
        axiosOptions.data += '&imbox=true';
      }

      try {
        var currentAkamaiWaitCookieValue = this.props.passedAppFunctions.getCookie('cma');
        if (
          currentAkamaiWaitCookieValue != '02140' &&
          currentAkamaiWaitCookieValue != '02139' &&
          currentAkamaiWaitCookieValue != '02138'
        ) {
          var domain = window.location.hostname;
          if (window.location.hostname != 'localhost') {
            domain = '.' + window.location.hostname;
          }
          Cookies.set('cma', '02140', {
            path: '/',
            domain: domain,
          });
        }
      } catch (e) {
        console.log(e);
      }

      axios(axiosOptions)
        .then((ajaxResponse) => {
          var cmdRespIsJSON;
          var responseJSON = {};
          var currentproductListAddQty;
          try {
            responseJSON = typeof ajaxResponse.data == 'object' ? ajaxResponse.data : JSON.parse(ajaxResponse.data);
            cmdRespIsJSON = true;
          } catch (e) {}
          if (cmdRespIsJSON) {
            //update state with the new information
            responseJSON.selectedMainImg = this.state.selectedMainImg;
            try {
              if (window.injectedImageAddToBag)
                responseJSON.selectedMainImg = window.injectedImageAddToBag(this.state.selectedMainImg);
            } catch (e) {}
            responseJSON.productNameForURL = this.props.contentData.productNameForURL;
            responseJSON.partNumber = this.props.contentData.partNumber;
            if (
              this.props.contentData.productLayout.indexOf('QuickView') > -1 &&
              !(
                this.props.contentData.extraQVProps &&
                this.props.passedAppFunctions.siteFormat != 'mobile' &&
                (this.props.contentData.extraQVProps.OSS || this.props.contentData.extraQVProps.collection)
              )
            ) {
              this.props.passedAppFunctions.closeQuickView();
            }
            responseJSON.currentOSSAccessories = this.state.currentOSSAccessories;
            responseJSON.currentCollection = this.state.currentCollection;
            this.props.passedAppFunctions.setModalInfo(responseJSON);

            if (responseJSON.modalType == 'InventoryModal') {
              this.props.passedAppFunctions.setDataLayerInfo('itemAddedInfo', {
                childPartNumber:
                  responseJSON.addedItems && responseJSON.addedItems[0] && responseJSON.addedItems[0].partNumber
                    ? responseJSON.addedItems[0].partNumber
                    : '',
                quantityAdded: responseJSON.addedQty || '',
                priceAdded: responseJSON.priceDisplayed || responseJSON.priceAdded || '',
                quantityRequested: responseJSON.qtyRequested || '',
                fullImage: this.state.selectedMainImg || this.props.contentData.fullImage.imageNameNoPath,
                productName: this.props.contentData.productName,
                productBrand: this.props.contentData.brandNameForTitle,
                parentPartNumber:
                  responseJSON.recJSON &&
                  responseJSON.recJSON.promotedDetails &&
                  responseJSON.recJSON.promotedDetails[0] &&
                  responseJSON.recJSON.promotedDetails[0].pid
                    ? responseJSON.recJSON.promotedDetails[0].pid
                    : '',
              });

              this.props.passedAppFunctions.setDataLayerInfo('productListItems', [
                {
                  SKU:
                    responseJSON.recJSON &&
                    responseJSON.recJSON.promotedDetails &&
                    responseJSON.recJSON.promotedDetails[0] &&
                    responseJSON.recJSON.promotedDetails[0].pid
                      ? responseJSON.recJSON.promotedDetails[0].pid
                      : '',
                  quantity: responseJSON.addedQty || '',
                  priceTotal:
                    (Math.round(responseJSON.priceDisplayed * 100) * responseJSON.addedQty) / 100 ||
                    (Math.round(responseJSON.priceAdded * 100) * responseJSON.addedQty) / 100 ||
                    '',
                  name:
                    this.props.contentData.brandNameForTitle +
                    ' ' +
                    this.props.contentData.productName
                      .split('#double;')
                      .join('"')
                      .split('-')
                      .join(' ')
                      .replace(/[^a-zA-Z 0-9\&]/g, ''),
                },
              ]);
              if (
                !responseJSON.addedQty ||
                responseJSON.addedQty == '' ||
                responseJSON.addedQty == '0' ||
                responseJSON.addedQty == 0
              ) {
                this.props.passedAppFunctions.setDataLayerInfo('flags', { ItemNotAdded: 'Y' });
              } else if (dataLayer && dataLayer.flags && dataLayer.flags.ItemNotAdded) {
                delete dataLayer.flags['ItemNotAdded'];
                if (dataLayer.flags && dataLayer.flags.length == undefined) {
                  delete dataLayer['flags'];
                }
              }
            } else {
              this.props.passedAppFunctions.setDataLayerInfo('itemAddedInfo', {
                childPartNumber: responseJSON.childPartnumberAdded || '',
                quantityAdded: responseJSON.quantityAdded || '',
                priceAdded: responseJSON.priceAdded || '',
                quantityRequested: responseJSON.quantityRequested || '',
                fullImage: this.state.selectedMainImg || this.props.contentData.fullImage.imageNameNoPath,
                productName: this.props.contentData.productName,
                productBrand: this.props.contentData.brandNameForTitle,
                parentPartNumber:
                  responseJSON.recJSON &&
                  responseJSON.recJSON.promotedDetails &&
                  responseJSON.recJSON.promotedDetails[0] &&
                  responseJSON.recJSON.promotedDetails[0].pid
                    ? responseJSON.recJSON.promotedDetails[0].pid
                    : '',
              });

              this.props.passedAppFunctions.setDataLayerInfo('productListItems', [
                {
                  SKU:
                    responseJSON.recJSON &&
                    responseJSON.recJSON.promotedDetails &&
                    responseJSON.recJSON.promotedDetails[0] &&
                    responseJSON.recJSON.promotedDetails[0].pid
                      ? responseJSON.recJSON.promotedDetails[0].pid
                      : '',
                  quantity: responseJSON.quantityAdded || '',
                  priceTotal: (Math.round(responseJSON.priceAdded * 100) * responseJSON.quantityAdded) / 100 || '',
                  name:
                    this.props.contentData.brandNameForTitle +
                    ' ' +
                    this.props.contentData.productName
                      .split('#double;')
                      .join('"')
                      .split('-')
                      .join(' ')
                      .replace(/[^a-zA-Z 0-9\&]/g, ''),
                },
              ]);

              if (
                !responseJSON.addedQty ||
                responseJSON.addedQty == '' ||
                responseJSON.addedQty == '0' ||
                responseJSON.addedQty == 0
              ) {
                this.props.passedAppFunctions.setDataLayerInfo('flags', { ItemNotAdded: 'Y' });
              } else if (dataLayer && dataLayer.flags && dataLayer.flags.ItemNotAdded) {
                delete dataLayer.flags['ItemNotAdded'];
                if (dataLayer.flags && dataLayer.flags.length == undefined) {
                  delete dataLayer['flags'];
                }
              }
            }

            try {
              if (origCartQty * 1 == 0) {
                this.props.passedAppFunctions.setDataLayerInfo('commerce', {
                  productListOpens: { value: 1 },
                  productListAdds: { value: 1 },
                });
                if (dataLayer && dataLayer.flags && dataLayer.flags.ItemNotAdded == 'Y') {
                  this.props.passedAppFunctions.setDataLayerInfo('commerce', { productListAdds: { value: 0 } });
                }
              } else {
                this.props.passedAppFunctions.setDataLayerInfo('commerce', { productListAdds: { value: 1 } });
                if (
                  dataLayer &&
                  dataLayer.flags &&
                  dataLayer.flags.ItemNotAdded == 'Y' &&
                  dataLayer.commerce &&
                  dataLayer.commerce.productListAdds.value > 0
                ) {
                  currentproductListAddQty = dataLayer.commerce.productListAdds.value - 1;
                  this.props.passedAppFunctions.setDataLayerInfo('commerce', {
                    productListAdds: { value: currentproductListAddQty },
                  });
                }
              }
            } catch (e) {
              this.props.passedAppFunctions.setDataLayerInfo('commerce', { productListAdds: { value: 1 } });
            }

            try {
              if (window.injectedAfterAddToBag) window.injectedAfterAddToBag(this.props.contentData.productId);
            } catch (e) {}

            this.resetFreqOnMount();
            this.personalizationTracking(6);
            //MODAL
          } else {
            //something errored...
            // this was breaking page styling -  trying to redirect to an error page and loading header and footer into the appended div
            // $('.errorAddingToBag').remove();
            // var newHTML = '<div class="errorAddingToBag hidden">Error Adding to cart: '+ ajaxResponse.data + '</div>';
            // if (ajaxResponse.data.indexOf('<body class="off-canvas" id="layoutProduct">') > -1) {
            // 	newHTML = '<div class="errorAddingToBag hidden">Error Adding to cart: </div>';
            // 	$('#ProductDisplay').append(newHTML);
            // } else {
            // 	$('#ProductDisplay').append(newHTML);
            // }

            this.props.passedAppFunctions.setModalInfo({ modalType: false });
            this.setState({
              wlResponse: {
                error: 'There was an error adding this item to your bag. Please try again later.',
              },
            });
          }
          this.setState({
            addToBagClicked: false,
          });
          this.props.passedAppFunctions.fetchContextAPI();
        })
        .catch((err) => {
          console.log(err, 'errror in add to bag');
          this.props.passedAppFunctions.setModalInfo({ modalType: false });
          this.setState({
            wlResponse: {
              error: 'There was an error adding this item to your bag. Please try again later.',
            },
          });
        });
    }
  }
  ajaxMonogramPersonalization(element) {
    window.doTheAjaxMonogramPersonalization(element, this);
  }
  ajaxAddToRegistry(result) {
    this.state.addToBagClicked = true;
    this.state.wlResponse = false;
    this.addErrorVisuals(result);
    if (this.validateForm(this.state.attributeState)) {
      var axiosOptions = {
        method: 'post',
        url: '/webapp/wcs/stores/servlet/ItemRegistryAdd',
      };
      axiosOptions.data = this.generateSharedFormFields();
      axiosOptions.data += '&field2=' + this.generateCachedAttributes();
      axios(axiosOptions).then((ajaxResponse) => {
        var cmdRespIsJSON;
        var responseJSON = {};
        try {
          responseJSON = typeof ajaxResponse.data == 'object' ? ajaxResponse.data : JSON.parse(ajaxResponse.data);
          cmdRespIsJSON = true;
        } catch (e) {}
        if (cmdRespIsJSON) {
          //update state with the new information
          responseJSON.selectedMainImg = this.state.selectedMainImg;
          responseJSON.productNameForURL = this.props.contentData.productNameForURL;
          responseJSON.partNumber = this.props.contentData.partNumber;
          responseJSON.registryAdd = true;

          this.setState({ wlResponse: responseJSON });
          //MODAL
        } else {
          var html = ajaxResponse.data;
          var forwardURL;
          if (html.search('forgot-password') > 0) {
            forwardURL = `https://${window.location.host}/webapp/wcs/stores/servlet/ItemRegistryAdd?`;
            forwardURL += this.generateSharedFormFields({
              URL: String(window.location).split('?')[0],
              rURL: String(window.location).split('?')[0],
            });

            this.storeAttempt('reg');

            window.location = forwardURL;
          } else if (html.search('createRegistry') > 0) {
            forwardURL = `https://${window.location.host}/webapp/wcs/stores/servlet/RegistryCreate?`;
            forwardURL += this.generateSharedFormFields({
              URL: String(window.location).split('?')[0],
              rURL: String(window.location).split('?')[0],
            });

            this.storeAttempt('reg');

            window.location = forwardURL;
          } else {
            this.setState({
              wlResponse: {
                registryAdd: true,
                error: 'There was an error adding this item to your registry. Please try again later.',
              },
            });
          }
        }
        this.setState({
          addToBagClicked: false,
        });
      });
    }
  }
  ajaxShareProductModal() {
    this.props.passedAppFunctions.setModalInfo({ modalType: 'Loading' });
    var axiosOptions = {
      method: 'post',
      url: '/webapp/wcs/stores/servlet/ProductEmail',
    };
    axiosOptions.data = 'returnJSON=true';
    axios(axiosOptions).then((ajaxResponse) => {
      var cmdRespIsJSON;
      var responseJSON = {};
      try {
        responseJSON = typeof ajaxResponse.data == 'object' ? ajaxResponse.data : JSON.parse(ajaxResponse.data);
        cmdRespIsJSON = true;
      } catch (e) {}
      if (cmdRespIsJSON) {
        //update state with the new information
        responseJSON.selectedMainImg = this.state.selectedMainImg;
        responseJSON.productNameForURL = this.props.contentData.productNameForURL;
        responseJSON.partNumber = this.props.contentData.partNumber;
        responseJSON.productName = this.props.contentData.originalProductName
          .split('#double;')
          .join('"')
          .split('&quot;')
          .join('"');
        responseJSON.productId = this.props.contentData.productId;
        this.props.passedAppFunctions.setModalInfo(responseJSON);
        //MODAL
      } else {
        //something errored...
      }
    });
  }
  ajaxAddToWishlist(result) {
    this.state.addToBagClicked = true;
    this.state.wlResponse = false;
    this.addErrorVisuals(result);

    if (this.validateForm(this.state.attributeState)) {
      var axiosOptions = {
        method: 'post',
        url: '/webapp/wcs/stores/servlet/InterestItemAdd',
      };
      axiosOptions.data = this.generateSharedFormFields();
      axiosOptions.data += '&field3=' + this.generateCachedAttributes();
      const categoryToAddPointsTo = this.getPersonalizationCategoryId();
      if (categoryToAddPointsTo) axiosOptions.data += `&field2=${categoryToAddPointsTo}`;

      let catentryId = this.getCatentryId();
      let skusList = this.props.contentData.skus;
      let matchingSKU = skusList.find((sku) => sku.catentryId === catentryId);
      let isOnSale = false;
      if (matchingSKU) {
        isOnSale = matchingSKU.offer.isOnSale;
      }
      if (isOnSale) {
        axiosOptions.data += '&itemOnSale=' + true;
      }

      axios(axiosOptions)
        .then((ajaxResponse) => {
          var cmdRespIsJSON;
          var responseJSON = {};
          if (typeof ajaxResponse.data != 'object') {
            try {
              responseJSON = JSON.parse(ajaxResponse.data);
              cmdRespIsJSON = true;
            } catch (e) {}
          } else {
            responseJSON = ajaxResponse.data;
            cmdRespIsJSON = true;
          }
          if (cmdRespIsJSON) {
            //update state with the new information
            this.setState({ wlResponse: responseJSON });
            this.personalizationTracking(12);
          } else if (ajaxResponse.data.indexOf('forgot-password') > -1) {
            var forwardURL = `https://${window.location.host}/webapp/wcs/stores/servlet/InterestItemAdd?`;
            forwardURL += this.generateSharedFormFields({
              URL: String(window.location).split('?')[0],
              rURL: String(window.location).split('?')[0],
            })
              .split('&returnJSON=true')
              .join('');
            forwardURL += '&field3=' + this.generateCachedAttributes();
            const categoryToAddPointsTo = this.getPersonalizationCategoryId();
            if (categoryToAddPointsTo) forwardURL += axiosOptions.data += `&field2=${categoryToAddPointsTo}`;
            this.storeAttempt('wl');

            window.location = forwardURL;
          } else {
            this.setState({ wlResponse: { result: 'failure' } });
          }
          this.setState({
            addToBagClicked: false,
          });
        })
        .finally(() => {
          try {
            $(document).trigger('addToWishlist');
          } catch (e) {
            console.log('triggering addToWishlist error', e);
          }
        });
    }
  }
  storeAttempt(prefix) {
    if (window.Modernizr && Modernizr.sessionstorage) {
      var storageString = '';
      if (prefix != 'mfb') {
        Object.values(this.state.currentAttributeState).map((thisAttr) => {
          if (storageString.length > 0) {
            storageString += '|';
          }
          storageString += `${thisAttr.attrName}:${thisAttr.selectedValue}`;
        });
      }
      if (storageString.length == 0) {
        sessionStorage.setItem(`${prefix}Attempt`, '-');
      } else {
        sessionStorage.setItem(`${prefix}Attempt`, storageString);
      }
      sessionStorage.setItem('attemptId', this.props.contentData.productId);
    }
  }
  flatSizesPriceObject() {
    if (this.state.itemPriceInfo) {
      var returnPricing = JSON.parse(JSON.stringify(this.props.contentData.pricing));
      if (!this.state.itemPriceInfo.itemOnSale) {
        returnPricing.onSpecial = '0';
      }
      if (this.state.itemPriceInfo.itemPrice) {
        returnPricing.oldOfferPriceMin = returnPricing.offerPriceMin;
        returnPricing.oldOfferPriceMax = returnPricing.offerPriceMax;
        returnPricing.offerPriceMin = this.state.itemPriceInfo.itemPrice;
        returnPricing.offerPriceMax = this.state.itemPriceInfo.itemPrice;
      }
      returnPricing.flatObject = true;
      return returnPricing;
    } else {
      var colorIsSelected = false;
      var selectedColorId = {};
      if (this.state.currentAttributeState['Color']?.selectedValue) {
        colorIsSelected = true;
        selectedColorId = this.state.currentAttributeState['Color']?.selectedValue;
      }
      const skusWithSelectedAttrs = this.props.contentData.skus.filter((sku) => {
        return sku?.definingAttributes?.every((attribute) => {
          if (
            this.state.currentAttributeState[attribute.name]?.selectedValue &&
            this.state.currentAttributeState[attribute.name]?.selectedValue != attribute.value.value
          ) {
            return false;
          }
          return true;
        });
      });
      const { pricingObj } = this.buildSwatchGroupsFromSkus(
        this.props.contentData,
        skusWithSelectedAttrs?.length === 0 ? this.props.contentData.skus : skusWithSelectedAttrs
      );
      if (Object.keys(pricingObj).length === 1) {
        //if we have selected enough to fall into a single price group,use that group at the top of page

        return Object.values(pricingObj)[0].pricing;
      }
      return this.props.contentData.pricing;
    }
  }
  closeWishListMessage() {
    this.setState({ wlResponse: false });
  }
  mainImageClicked() {
    this.setState({ imageClickedOn: true });
  }
  zoomedImageClose() {
    this.setState({ imageClickedOn: false });
  }
  personalizationTracking(pointValue) {
    try {
      if (Modernizr?.localstorage && Modernizr?.sessionstorage) {
        const categoryIdToTrackAs = this.getPersonalizationCategoryId();
        const brandName = this?.props?.contentData?.personalization?.brandName || '';
        if (categoryIdToTrackAs && brandName) {
          updatePersonalizationStorage(
            this.props.passedAppFunctions.wasParms,
            categoryIdToTrackAs,
            brandName,
            pointValue,
            'personalization'
          );
          this.sizePersonalizationTracking(pointValue, categoryIdToTrackAs);
        }
      }
    } catch (e) {
      // console.log(e);
    }
  }
  sizePersonalizationTracking(pointValue, superId) {
    try {
      if (pointValue > 1 && supersToDoSizeTracking.indexOf(superId) > -1) {
        if (
          this.state.attributeState &&
          this.state.attributeState.attributes &&
          this.state.attributeState.attributes.length > 0
        ) {
          for (var iAttr = 0; iAttr < this.state.attributeState.attributes.length; iAttr++) {
            var selectedAttrStandardSize =
              this.state.attributeState.attributes[iAttr].selectedValueInformation.standardSize;
            if (selectedAttrStandardSize) {
              selectedAttrStandardSize = selectedAttrStandardSize.split('&').join('&amp;');
              updatePersonalizationStorage(
                this.props.passedAppFunctions.wasParms,
                superId,
                selectedAttrStandardSize,
                pointValue,
                'ss'
              );
            }
          }
        }
      }
    } catch (e) {
      // console.log(e);
    }
  }

  thisBrandInMyFavorites() {
    if (this.props.passedAppFunctions.myDillardsInfo.userInformation.persistent !== undefined) {
      var thisMfName = this.props.contentData.brandNameForTitle;
      var thisPersonalizationId = this.getPersonalizationCategoryId();
      try {
        const brandArray = getFavoritedBrandsByCategoryid(thisPersonalizationId);
        return brandArray.includes(thisMfName);
      } catch (e) {}
    }
    return false;
  }

  getPersonalizationCategoryId() {
    const thisProductsCatGroupIdNames = this?.props?.contentData?.personalization?.catgroupIdNames;
    const catGroupIdNamesToUse =
      thisProductsCatGroupIdNames?.length > 0
        ? thisProductsCatGroupIdNames
        : this?.props?.parentPersonalization?.catgroupIdNames;
    return this.props.passedAppFunctions.wasParms.personalizationCategoryIds.split('|').find((catgroupIdToTrackAs) => {
      return catGroupIdNamesToUse?.find((catgroupIdName) => {
        const productCatgroupId = catgroupIdName.split('|')[0].split('301_')[1];
        return productCatgroupId === catgroupIdToTrackAs;
      });
    });
  }

  returnItemColorOrTrueIfMonogramEligible() {
    var attrOne,
      attrTwo,
      iAttr = 0,
      returnBool = false;
    if (this.validateForm(this.state.attributeState)) {
      for (iAttr; iAttr < this.state.attributeState.attributes.length; iAttr++) {
        typeof attrOne == 'undefined'
          ? (attrOne = this.state.attributeState.attributes[iAttr])
          : (attrTwo = this.state.attributeState.attributes[iAttr]);
      }
      if (iAttr == 2 && attrOne.selectedValueInformation.othersMonogram) {
        var attrOneOthersMonogram = attrOne.selectedValueInformation.othersMonogram.split('|');
        for (var iaoom = 0; iaoom < attrOneOthersMonogram.length; iaoom++) {
          if (
            attrTwo.selectedValueInformation.name == attrOneOthersMonogram[iaoom].split(':')[0] &&
            attrOneOthersMonogram[iaoom].split(':')[1] == 'true'
          ) {
            if (attrTwo.attrName == 'Color') {
              returnBool = attrTwo.selectedValueInformation.name;
            } else {
              returnBool = true;
            }
          }
        }
      } else if (iAttr == 1 && attrOne.selectedValueInformation.singleAttrMonogram) {
        if (attrOne.selectedValueInformation.singleAttrMonogram == 'true') {
          if (attrOne.attrName == 'Color') {
            returnBool = attrOne.selectedValueInformation.name;
          } else {
            returnBool = true;
          }
        }
      } else if (iAttr == 0 && this.props.contentData.monogramEligible) {
        if (this.props.contentData.monogramEligible == 'true') returnBool = true;
      }
    }
    return returnBool;
  }
  thisItemMonogramEligible() {
    // var attrOne,
    // 	attrTwo,
    // 	iAttr = 0,
    // 	returnBool = false;
    // if (this.validateForm(this.state.attributeState)) {
    // 	for (iAttr; iAttr < this.state.attributeState.attributes.length; iAttr++) {
    // 		typeof attrOne == 'undefined' ? (attrOne = this.state.attributeState.attributes[iAttr]) : (attrTwo = this.state.attributeState.attributes[iAttr]);
    // 	}
    // 	if (iAttr == 2 && attrOne.selectedValueInformation.othersMonogram) {
    // 		var attrOneOthersMonogram = attrOne.selectedValueInformation.othersMonogram.split('|');
    // 		for (var iaoom = 0; iaoom < attrOneOthersMonogram.length; iaoom++) {
    // 			if (attrTwo.selectedValueInformation.name == attrOneOthersMonogram[iaoom].split(':')[0] && attrOneOthersMonogram[iaoom].split(':')[1] == 'true')
    // 				returnBool = true;
    // 		}
    // 	} else if (iAttr == 1 && attrOne.selectedValueInformation.singleAttrMonogram) {
    // 		if (attrOne.selectedValueInformation.singleAttrMonogram == 'true') returnBool = true;
    // 	} else if (iAttr == 0 && this.props.contentData.monogramEligible) {
    // 		if (this.props.contentData.monogramEligible == 'true') returnBool = true;
    // 	}
    // }
    // return returnBool;
  }

  setCurrentOSSAccessories = (currentOSSAccessories) => {
    this.state.currentOSSAccessories = currentOSSAccessories;
  };
  setCurrentCollection = (currentCollection) => {
    this.state.currentCollection = currentCollection;
  };

  populateDdsStyliticsWidgetInstance = (colorWay) => {
    try {
      window.rerunStyliticsColorway = colorWay;
      $('.stylitics-sequence-scroll-snap').css('overflow-x', 'scroll');
      $('body').css('overflow', '');

      if (this.props.passedAppFunctions.wasParms.displayStyliticsWidget == 'true') {
        if (typeof Cookies === 'object' && Cookies.get('zCountry') && Cookies.get('zCountry') == 'US') {
          let widgetContainer = document.getElementById('dds-stylitics-widget');
          if (widgetContainer && widgetContainer.style && widgetContainer.style.display) {
            widgetContainer.style.display = '';
          }

          if (null != widgetContainer) {
            var deviceType = this.props.passedAppFunctions.siteFormat;
            var widgetFunction = this.startStyliticsWidget;
            if (typeof StyliticsClassicWidget === 'function') {
              //stylitics js has loaded, initialize widget
              widgetFunction(colorWay, deviceType);
            } else {
              //waiting for tag manager to load js, will initialize widget once ready (15s timeout)
              var styliticsInterval = setInterval(function () {
                if (typeof StyliticsClassicWidget === 'function') {
                  widgetFunction(colorWay, deviceType);
                  clearInterval(styliticsInterval);
                }
              }, 250);

              setTimeout(function () {
                clearInterval(styliticsInterval);
              }, 15000);
            }
          }
        }
        this.state.countryCookieUndefined = Cookies.get('zCountry') === undefined ? true : false;
      }
    } catch (e) {
      console.log(e);
    }
  };

  startStyliticsWidget(colorWay, deviceType) {
    try {
      if (window.ddsStyliticsWidgetInstance) {
        window.ddsStyliticsWidgetInstance.destroy();
      }

      var displayProps = {};
      // displayProps.disableMnM = true;
      displayProps.hideAnchorItem = true;
      if (deviceType == 'tablet') displayProps.bundleProductList = 'product-list-on-click';

      window.ddsStyliticsWidgetInstance = new StyliticsClassicWidget(
        window.location.hostname.indexOf('www.dillards.com') > -1 ? 'dillards' : 'dillards_staging',
        'dds-stylitics-widget-container',
        {
          api: {
            item_number: colorWay,
            min: 1,
            max: 25,
          },
          display: displayProps,
        }
      );

      ddsStyliticsWidgetInstance.on('mount', 'bundles', function (data) {
        let widgetContainer = document.getElementById('dds-stylitics-widget');
        let titleElement = document.getElementById('dds-stylitics-widget-title');
        let jumplinkElement = document.getElementById('stylitics-jumplink');

        if (data.bundles && data.bundles.length > 0) {
          widgetContainer.style.display = '';
          titleElement.style.display = '';
          jumplinkElement.style.display = 'inline-block';
        } else {
          widgetContainer.style.display = 'none';
          titleElement.style.display = 'none';
          jumplinkElement.style.display = '';
        }
      });

      ddsStyliticsWidgetInstance.on('click', 'bundle', function () {
        //on modal open
        try {
          if (
            document.getElementById('dds-stylitics-widget') &&
            document
              .getElementById('dds-stylitics-widget')
              .querySelector('.stylitics-desktop-modal-close, .stylitics-close, .stylitics-modal')
          ) {
            if (document.getElementsByClassName('AddtoCartModal').length === 0) {
              if (
                ddsStyliticsWidgetInstance.widgetVisibility &&
                ddsStyliticsWidgetInstance.widgetVisibility.experiences &&
                ddsStyliticsWidgetInstance.widgetVisibility.experiences.formatted &&
                ddsStyliticsWidgetInstance.widgetVisibility.experiences.formatted.mixAndMatch &&
                ddsStyliticsWidgetInstance.widgetVisibility.experiences.formatted.mixAndMatch === true
              ) {
                document.getElementsByTagName('body')[0].style.overflowY = 'hidden';
              } else {
                if ($('.mobilePage').length > 0) {
                  $('.stylitics-sequence-scroll-snap').css('overflow-x', 'hidden');
                  $('body').css('overflow', 'hidden');
                }
              }
            }
          } else {
            var styliticsTabletCheckPDPInterval = setInterval(function () {
              if (
                document.getElementById('dds-stylitics-widget') &&
                document
                  .getElementById('dds-stylitics-widget')
                  .querySelector('.stylitics-desktop-modal-close, .stylitics-close, .stylitics-modal')
              ) {
                if (document.getElementsByClassName('AddtoCartModal').length === 0) {
                  if (
                    ddsStyliticsWidgetInstance.widgetVisibility &&
                    ddsStyliticsWidgetInstance.widgetVisibility.experiences &&
                    ddsStyliticsWidgetInstance.widgetVisibility.experiences.formatted &&
                    ddsStyliticsWidgetInstance.widgetVisibility.experiences.formatted.mixAndMatch &&
                    ddsStyliticsWidgetInstance.widgetVisibility.experiences.formatted.mixAndMatch === true
                  ) {
                    document.getElementsByTagName('body')[0].style.overflowY = 'hidden';
                  } else {
                    if ($('.mobilePage').length > 0) {
                      $('.stylitics-sequence-scroll-snap').css('overflow-x', 'hidden');
                      $('body').css('overflow', 'hidden');
                    }
                  }
                }
                clearInterval(styliticsTabletCheckPDPInterval);
              }
            }, 250);

            setTimeout(function () {
              clearInterval(styliticsTabletCheckPDPInterval);
            }, 5000);
          }
        } catch (e) {
          console.log(e);
        }

        //on modal close
        try {
          if (
            $(
              '#dds-stylitics-widget .stylitics-desktop-modal-close, #dds-stylitics-widget .stylitics-close, #dds-stylitics-widget .stylitics-modal'
            ).length > 0
          ) {
            //close button selector
            $('#dds-stylitics-widget .stylitics-desktop-modal-close, #dds-stylitics-widget .stylitics-close').off(
              'click.styliticsClose'
            );
            $('#dds-stylitics-widget .stylitics-desktop-modal-close, #dds-stylitics-widget .stylitics-close').on(
              'click.styliticsClose',
              function (evt) {
                if (document.getElementsByClassName('AddtoCartModal').length === 0) {
                  if (
                    ddsStyliticsWidgetInstance.widgetVisibility &&
                    ddsStyliticsWidgetInstance.widgetVisibility.experiences &&
                    ddsStyliticsWidgetInstance.widgetVisibility.experiences.formatted &&
                    ddsStyliticsWidgetInstance.widgetVisibility.experiences.formatted.mixAndMatch &&
                    ddsStyliticsWidgetInstance.widgetVisibility.experiences.formatted.mixAndMatch === true
                  ) {
                    document.getElementsByTagName('body')[0].style.overflowY = '';
                  } else {
                    $('.stylitics-sequence-scroll-snap').css('overflow-x', 'scroll');
                    $('body').css('overflow', '');
                  }
                }
              }
            );
            //overlay selector desktop
            $('#dds-stylitics-widget .stylitics-desktop-modal-scrim').off('click.styliticsDesktopModal');
            $('#dds-stylitics-widget .stylitics-desktop-modal-scrim').on('click.styliticsDesktopModal', function (evt) {
              let styliticsModalSelector = document.querySelector(
                '#dds-stylitics-widget .stylitics-desktop-modal-scrim'
              );
              if (
                null === styliticsModalSelector ||
                (styliticsModalSelector &&
                  null === styliticsModalSelector.querySelector('.' + evt.target.classList.value.split(' ').join('.')))
              ) {
                if (document.getElementsByClassName('AddtoCartModal').length === 0) {
                  if (
                    ddsStyliticsWidgetInstance.widgetVisibility &&
                    ddsStyliticsWidgetInstance.widgetVisibility.experiences &&
                    ddsStyliticsWidgetInstance.widgetVisibility.experiences.formatted &&
                    ddsStyliticsWidgetInstance.widgetVisibility.experiences.formatted.mixAndMatch &&
                    ddsStyliticsWidgetInstance.widgetVisibility.experiences.formatted.mixAndMatch === true
                  ) {
                    document.getElementsByTagName('body')[0].style.overflowY = '';
                  } else {
                    $('.stylitics-sequence-scroll-snap').css('overflow-x', 'scroll');
                    $('body').css('overflow', '');
                  }
                }
              }
            });
            //overlay selector tablet & mobile
            $('#dds-stylitics-widget .stylitics-modal').off('click.styliticsModal');
            $('#dds-stylitics-widget .stylitics-modal').on('click.styliticsModal', function (evt) {
              let styliticsModalSelector = document.querySelector('#dds-stylitics-widget .stylitics-modal');
              if (
                null === styliticsModalSelector ||
                (styliticsModalSelector &&
                  null === styliticsModalSelector.querySelector('.' + evt.target.classList.value.split(' ').join('.')))
              ) {
                if (document.getElementsByClassName('AddtoCartModal').length === 0) {
                  if (
                    ddsStyliticsWidgetInstance.widgetVisibility &&
                    ddsStyliticsWidgetInstance.widgetVisibility.experiences &&
                    ddsStyliticsWidgetInstance.widgetVisibility.experiences.formatted &&
                    ddsStyliticsWidgetInstance.widgetVisibility.experiences.formatted.mixAndMatch &&
                    ddsStyliticsWidgetInstance.widgetVisibility.experiences.formatted.mixAndMatch === true
                  ) {
                    document.getElementsByTagName('body')[0].style.overflowY = '';
                  } else {
                    $('.stylitics-sequence-scroll-snap').css('overflow-x', 'scroll');
                    $('body').css('overflow', '');
                  }
                }
              }
            });
          } else {
            var styliticsModalInterval = setInterval(function () {
              if (
                $(
                  '#dds-stylitics-widget .stylitics-desktop-modal-close, #dds-stylitics-widget .stylitics-close, #dds-stylitics-widget .stylitics-modal'
                ).length > 0
              ) {
                //close button selector
                $('#dds-stylitics-widget .stylitics-desktop-modal-close, #dds-stylitics-widget .stylitics-close').off(
                  'click.styliticsClose'
                );
                $('#dds-stylitics-widget .stylitics-desktop-modal-close, #dds-stylitics-widget .stylitics-close').on(
                  'click.styliticsClose',
                  function (evt) {
                    if (document.getElementsByClassName('AddtoCartModal').length === 0) {
                      if (
                        ddsStyliticsWidgetInstance.widgetVisibility &&
                        ddsStyliticsWidgetInstance.widgetVisibility.experiences &&
                        ddsStyliticsWidgetInstance.widgetVisibility.experiences.formatted &&
                        ddsStyliticsWidgetInstance.widgetVisibility.experiences.formatted.mixAndMatch &&
                        ddsStyliticsWidgetInstance.widgetVisibility.experiences.formatted.mixAndMatch === true
                      ) {
                        document.getElementsByTagName('body')[0].style.overflowY = '';
                      } else {
                        $('.stylitics-sequence-scroll-snap').css('overflow-x', 'scroll');
                        $('body').css('overflow', '');
                      }
                    }
                  }
                );
                //overlay selector desktop
                $('#dds-stylitics-widget .stylitics-desktop-modal-scrim').off('click.styliticsDesktopModal');
                $('#dds-stylitics-widget .stylitics-desktop-modal-scrim').on(
                  'click.styliticsDesktopModal',
                  function (evt) {
                    let styliticsModalSelector = document.querySelector(
                      '#dds-stylitics-widget .stylitics-desktop-modal-scrim'
                    );
                    if (
                      null === styliticsModalSelector ||
                      (styliticsModalSelector &&
                        null ===
                          styliticsModalSelector.querySelector('.' + evt.target.classList.value.split(' ').join('.')))
                    ) {
                      if (document.getElementsByClassName('AddtoCartModal').length === 0) {
                        if (
                          ddsStyliticsWidgetInstance.widgetVisibility &&
                          ddsStyliticsWidgetInstance.widgetVisibility.experiences &&
                          ddsStyliticsWidgetInstance.widgetVisibility.experiences.formatted &&
                          ddsStyliticsWidgetInstance.widgetVisibility.experiences.formatted.mixAndMatch &&
                          ddsStyliticsWidgetInstance.widgetVisibility.experiences.formatted.mixAndMatch === true
                        ) {
                          document.getElementsByTagName('body')[0].style.overflowY = '';
                        } else {
                          $('.stylitics-sequence-scroll-snap').css('overflow-x', 'scroll');
                          $('body').css('overflow', '');
                        }
                      }
                    }
                  }
                );
                //overlay selector tablet
                $('#dds-stylitics-widget .stylitics-modal').off('click.styliticsModal');
                $('#dds-stylitics-widget .stylitics-modal').on('click.styliticsModal', function (evt) {
                  let styliticsModalSelector = document.querySelector('#dds-stylitics-widget .stylitics-modal');
                  if (
                    null === styliticsModalSelector ||
                    (styliticsModalSelector &&
                      null ===
                        styliticsModalSelector.querySelector('.' + evt.target.classList.value.split(' ').join('.')))
                  ) {
                    if (document.getElementsByClassName('AddtoCartModal').length === 0) {
                      if (
                        ddsStyliticsWidgetInstance.widgetVisibility &&
                        ddsStyliticsWidgetInstance.widgetVisibility.experiences &&
                        ddsStyliticsWidgetInstance.widgetVisibility.experiences.formatted &&
                        ddsStyliticsWidgetInstance.widgetVisibility.experiences.formatted.mixAndMatch &&
                        ddsStyliticsWidgetInstance.widgetVisibility.experiences.formatted.mixAndMatch === true
                      ) {
                        document.getElementsByTagName('body')[0].style.overflowY = '';
                      } else {
                        $('.stylitics-sequence-scroll-snap').css('overflow-x', 'scroll');
                        $('body').css('overflow', '');
                      }
                    }
                  }
                });
                clearInterval(styliticsModalInterval);
              }
            }, 250);

            setTimeout(function () {
              clearInterval(styliticsModalInterval);
            }, 5000);
          }
        } catch (e) {
          console.log(e);
        }
      });

      ddsStyliticsWidgetInstance.override('click', 'item', function (data) {
        //handle link click for outfit items
        var PID = data.item.affiliate_link.split('?')[0].slice(-9);
        var modalBodyValue = 'callQuickView({"catentryId":"' + PID + '","categoryId":"stylitics"})';
        var s = document.getElementsByClassName('stylitics-qv')[0];
        if (s && s.dataset) {
          s.dataset.modalBody = modalBodyValue;

          var colorName = data.item.remote_id;
          var removeChars = [
            '&reg;',
            '&trade;',
            '&ordm;',
            '<i>',
            '</i>',
            '"',
            "'",
            '+',
            ',',
            '\\',
            '&',
            '#',
            '%',
            '?',
            '<',
            '>',
            '/',
            ';',
            '´',
            '®',
            '[',
            ']',
            '™',
          ];
          var dashChars = ['  ', ' '];

          colorName = colorName.indexOf('-') > -1 ? colorName.split('-')[1] : colorName;
          colorName = colorName.replaceAll('[^a-zA-Z0-9 .|-]+', ' ');
          var i;
          for (i of removeChars) {
            colorName = colorName.replaceAll(i, ' ');
          }
          for (i of dashChars) {
            colorName = colorName.replaceAll(i, '-');
          }
          do {
            colorName = colorName.split('--').join('-');
          } while (colorName.indexOf('--') > -1);

          s.dataset.dfcolor = colorName.trim();
          s.dataset.pid = PID;
          s.click();
        }
      });

      ddsStyliticsWidgetInstance.start();
    } catch (e) {
      console.log(e);
    }
  }

  getStyliticsColor() {
    var selectedMainImg = this.state.selectedMainImg != '' ? this.state.selectedMainImg : '';
    var altImages = this.props.contentData && this.props.contentData.altImages ? this.props.contentData.altImages : [];
    if (
      altImages.length == 0 &&
      this.props.contentData.swatchGroups &&
      this.props.contentData.swatchGroups[0] &&
      this.props.contentData.swatchGroups[0].swatches &&
      this.props.contentData.swatchGroups[0].swatches[0]
    ) {
      if (selectedMainImg === this.props.contentData.swatchGroups[0].swatches[0].fullImage) {
        return this.props.contentData.swatchGroups[0].swatches[0].colorForSwatch;
      }
    } else {
      for (var thisAlt of altImages) {
        if (thisAlt.altText && thisAlt.imageName && thisAlt.imageName.indexOf(selectedMainImg) > -1) {
          return thisAlt.altText.split('Color:').join('').split(' - ')[0];
        }
      }
    }
    return '';
  }

  formatColorWay(pid, colorName) {
    try {
      var removeChars = [
        '&reg;',
        '&trade;',
        '&ordm;',
        '<i>',
        '</i>',
        '"',
        "'",
        '+',
        ',',
        '\\',
        '&',
        '#',
        '%',
        '?',
        '<',
        '>',
        '/',
        ';',
        '´',
        '®',
        '[',
        ']',
        '™',
      ];
      var dashChars = ['  ', ' '];

      if (!String.prototype.replaceAll) {
        String.prototype.replaceAll = function (str, newStr) {
          // If a regex pattern
          if (Object.prototype.toString.call(str).toLowerCase() === '[object regexp]') {
            return this.replace(str, newStr);
          }

          // If a string
          return this.replace(new RegExp(str, 'g'), newStr);
        };
      }

      if (colorName && colorName != '') {
        colorName = colorName.replaceAll('[^a-zA-Z0-9 .|-]+', ' ');
        var i;
        for (i of removeChars) {
          colorName = colorName.replaceAll(i, ' ');
        }

        for (i of dashChars) {
          colorName = colorName.replaceAll(i, '-');
        }

        do {
          colorName = colorName.split('--').join('-');
        } while (colorName.indexOf('--') > -1);

        var colorNameArry = [];
        for (i = 0; i < colorName.split('-').length; i++) {
          var word = colorName.split('-')[i];
          colorNameArry.push(word.charAt(0).toUpperCase() + word.slice(1));
        }

        return pid + '-' + colorNameArry.join('-');
      } else {
        return pid + '-' + colorName?.split(' ').join('-');
      }
    } catch (e) {
      return pid + '-' + colorName?.split(' ').join('-');
    }
  }

  passedFunctions() {
    return {
      parentState: JSON.parse(JSON.stringify(this.state)),
      currencySymbol: this.currencySymbol,
      priceConvert: this.priceConvert,
      updateQuantity: this.updateQuantity,
      forceQuantity: this.forceQuantity,
      updateAttribute: this.updateAttribute,
      updateAttributeFromAltClick: this.updateAttributeFromAltClick,
      updateAttributeFromAltSwipe: this.updateAttributeFromAltSwipe,
      ajaxAddToBag: this.ajaxAddToBag,
      ajaxAddToWishlist: this.ajaxAddToWishlist,
      ajaxAddToBrandFavorites: this.ajaxAddToBrandFavorites,
      flatSizesPriceObject: this.flatSizesPriceObject,
      colorNotAvailable: this.state.colorNotAvailable,
      closeWishListMessage: this.closeWishListMessage,
      mainImageClicked: this.mainImageClicked,
      zoomedImageClose: this.zoomedImageClose,
      ajaxShareProductModal: this.ajaxShareProductModal,
      ajaxAddToRegistry: this.ajaxAddToRegistry,
      shouldShowFreeShipping: this.shouldShowFreeShipping,
      willHaveFlatAttribute: this.willHaveFlatAttribute,
      thisBrandInMyFavorites: this.thisBrandInMyFavorites,
      getPersonalizationCategoryId: this.getPersonalizationCategoryId,
      forceBundleRender: this.forceBundleRender,
      addErrorVisuals: this.addErrorVisuals,
      addToBagClicked: this.addToBagClicked,
      formNotValid: this.formNotValid,
      returnItemColorOrTrueIfMonogramEligible: this.returnItemColorOrTrueIfMonogramEligible,
      showReviews: this.showReviews,
      thisItemMonogramEligible: this.thisItemMonogramEligible,
      ajaxMonogramPersonalization: this.ajaxMonogramPersonalization,
      roundUp: this.roundUp,
      setCurrentOSSAccessories: this.setCurrentOSSAccessories,
      setCurrentCollection: this.setCurrentCollection,
      checkForErrorsRegistry: this.checkForErrorsRegistry,
      checkForErrorsWishlist: this.checkForErrorsWishlist,
      checkForErrors: this.checkForErrors,
      hideCheckForErrors: this.hideCheckForErrors,
      checkForErrorsItemAttr: this.checkForErrorsItemAttr,
      checkForErrorsQV: this.checkForErrorsQV,
      checkForErrorsMonogram: this.checkForErrorsMonogram,
      updateLiveReviewCounts: this.updateLiveReviewCounts,
      focusFirstAttrError: this.focusFirstAttrError,
      updateSubscriptionFrequency: this.updateSubscriptionFrequency,
      updateLiveQuestionAnswersCount: this.updateLiveQuestionAnswersCount,
      changeMainImage: this.changeMainImage,
      altImageClicked: this.altImageClicked,
      updateAttributeState: this.updateAttributeState,
      changeAttributeState: this.changeAttributeState,
      allImages: this.state.allImages,
      getProductImagesArray: this.getProductImagesArray,
      getAttrName: this.getAttrName,
      getAttrId: this.getAttrId,
      getAttrType: this.getAttrType,
    };
  }
}

export default SharedProductDetail;
